import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
// ============================================
// DATA: 14 MAESTRI CON IPHONE E SIM SETTINGS
// ============================================
const MAESTRI = [
  // SCUOLA 1: GEOMETRIA E RIGORE
  {
    id: 'cartier-bresson',
    nome: 'Henri Cartier-Bresson',
    titolo: 'Il Momento Decisivo',
    scuola: 'Geometria e Rigore',
    tipo: 'bw',
    occhio: 'Geometrie in tensione con il movimento umano. Cerca linee, archi, scale, ombre diagonali — poi aspetta che una figura entri nel punto esatto dove tutto si tiene insieme per un istante.',
    corpo: 'Invisibile. Cammina lento, periferica attiva. Quando vedi la scena, ti fermi prima che succeda. Non insegui — anticipi. Si definiva un "borseggiatore" di immagini.',
    macchina: '35mm o 50mm. Priorità Diaframmi, f/8 fisso. Fuoco manuale a 3m (iperfocale). ISO Auto con minimo 1/500s.',
    iphone: {
      lente: '1x (24mm)',
      modo: 'Photo standard — NO Portrait',
      esposizione: 'Tocca su zona media, non regolare',
      focus: 'Non toccare — tutto a fuoco',
      editing: 'B/N • Contrasto +15 • Crop geometrico',
      tip: 'Scatta largo e veloce. Correggi il crop dopo. Il momento non aspetta.'
    },
    esempio: 'Sei in una piazza con una scalinata. Luce del mattino, ombre lunghe. Un uomo con cappello sta per scendere. Non scatti lui — scatti l\'istante in cui il suo piede incontra l\'ombra del corrimano.',
    settings: { aperture: 'f/8', shutter: '1/500s', iso: 'Auto', focal: '35-50mm' },
    simSettings: { aperture: 8, shutter: 60, iso: 400 },
    simRationale: 'f/8 per iperfocale — tutto a fuoco da 1.5m a infinito. 1/500s congela il momento decisivo.',
    missione: '🎯 Oggi: Trova una scena con geometria forte (scale, archi, ombre). Aspetta che una persona entri nel punto giusto. Scatta 20 volte la stessa scena — solo UNA sarà il momento decisivo.'
  },
  {
    id: 'wes-anderson',
    nome: 'Wes Anderson',
    titolo: 'La Simmetria Urbana',
    scuola: 'Geometria e Rigore',
    tipo: 'color',
    occhio: 'Simmetria ossessiva e palette cromatiche controllate. Cerca architetture frontali, superfici piatte, colori pastello. Il mondo come diorama perfetto.',
    corpo: 'Frontale e ortogonale. Ti posizioni esattamente al centro della scena, perpendicolare alla facciata. Niente angoli — solo equilibrio perfetto.',
    macchina: '35mm. f/11 per nitidezza piatta su tutto il frame. Composizione centrale millimetrica.',
    iphone: {
      lente: '1x (24mm)',
      modo: 'Photo standard • Griglia ON obbligatoria',
      esposizione: 'Auto',
      focus: 'Non toccare — nitidezza totale',
      editing: 'Saturazione pastello +15 • Contrasto -10 • WB caldo 6500K • Raddrizza prospettiva',
      tip: 'Posizionati PERPENDICOLARE alla facciata. Centra al millimetro sulla griglia.'
    },
    esempio: 'Una facciata Art Déco color salmone con tre finestre identiche. Ti fermi esattamente al centro. Aspetti che una persona con cappotto giallo attraversi — esattamente nel mezzo.',
    settings: { aperture: 'f/11', shutter: '1/250s', iso: '100-200', focal: '35mm' },
    simSettings: { aperture: 11, shutter: 8, iso: 100 },
    simRationale: 'f/11 per nitidezza totale su tutto il frame — nessun elemento sfocato nel diorama perfetto.',
    missione: '🎯 Oggi: Trova una facciata simmetrica. Posizionati esattamente al centro. Aspetta che passi qualcuno vestito con un colore che "stacca". Scatta solo quando è perfettamente centrato.'
  },
  {
    id: 'fan-ho',
    nome: 'Fan Ho',
    titolo: 'Il Teatro delle Ombre',
    scuola: 'Geometria e Rigore',
    tipo: 'bw',
    occhio: 'Luce e ombra come protagonisti assoluti. Cerca vicoli dove un taglio di sole crea un palcoscenico naturale — poi aspetta che una figura entri nella luce.',
    corpo: 'Statico e paziente. Scegli il palcoscenico di luce e aspetta l\'attore perfetto. A volte per ore. Scattava all\'alba o al tramonto.',
    macchina: 'Rolleiflex (formato quadrato). Misurazione Spot sulla luce più forte. ISO 100 per neri puri e profondi.',
    iphone: {
      lente: '1x o 2x',
      modo: 'Photo • Formato 1:1 (quadrato)',
      esposizione: 'Tocca e TIENI PREMUTO sulla zona ILLUMINATA — le ombre andranno in nero',
      focus: 'Sulla figura nella luce',
      editing: 'B/N • Neri +40 • Contrasto alto • Non recuperare ombre • Nitidezza +20',
      tip: 'Alba/tramonto per tagli di luce netti. Aspetta che la figura ENTRI nella luce.'
    },
    esempio: 'Un vicolo stretto a mezzogiorno. Un taglio di luce verticale divide il buio. Una donna con ombrello attraversa — per un istante è illuminata come su un palco.',
    settings: { aperture: 'f/8-11', shutter: '1/125s', iso: '100', focal: '35-50mm' },
    simSettings: { aperture: 8, shutter: 15, iso: 100 },
    simRationale: 'ISO 100 per neri purissimi e ombre profonde. Nessuna grana a disturbare il chiaroscuro.',
    missione: '🎯 Oggi: Cerca un vicolo o corridoio con un taglio di luce forte. Sottoesponi di 2 stop sul telefono. Aspetta che qualcuno attraversi la luce. Solo silhouette e controluce.'
  },
  
  // SCUOLA 2: SENTIMENTO E UMANO
  {
    id: 'ara-guler',
    nome: 'Ara Güler',
    titolo: 'Il Sentimento e la Memoria',
    scuola: 'Sentimento e Umano',
    tipo: 'bw',
    occhio: 'L\'umanità nella vita quotidiana. Cerca volti segnati dal tempo, gesti di lavoro, momenti avvolti nella foschia e malinconia — hüzün.',
    corpo: 'Empatico e presente. Sei un testimone che condivide lo spazio con il soggetto. Camminava per Istanbul come un poeta.',
    macchina: 'Leica, 35mm. ISO forzati a 1600/3200 per grana evidente. f/5.6. Misurazione Ponderata Centrale.',
    iphone: {
      lente: '1x (24mm)',
      modo: 'Photo standard • Luce fioca ok',
      esposizione: 'Tocca sul VISO — il resto può andare',
      focus: 'Sul volto',
      editing: 'B/N • Contrasto medio • Ombre +30 • Grana +40 • Seppia leggero 10%',
      tip: 'Il rumore di iPhone in poca luce QUI è tuo amico. Aggiungine altro in editing.'
    },
    esempio: 'Un venditore di tè in un vicolo di Istanbul. Nebbia, luce fioca. Non scatti il gesto — scatti il volto mentre guarda nel vuoto.',
    settings: { aperture: 'f/5.6', shutter: '1/60s', iso: '1600-3200', focal: '35mm' },
    simSettings: { aperture: 5.6, shutter: 500, iso: 1600 },
    simRationale: 'ISO alto per grana evidente — la texture si fonde con le rughe della pelle. La grana È l\'emozione.',
    missione: '🎯 Oggi: Vai in un bar, mercato o bottega. Chiedi a qualcuno se puoi fare un ritratto. Aspetta il momento in cui guarda altrove, pensieroso. La grana è tua amica.'
  },
  {
    id: 'dorothea-lange',
    nome: 'Dorothea Lange',
    titolo: 'La Testimonianza e la Dignità',
    scuola: 'Sentimento e Umano',
    tipo: 'bw',
    occhio: 'La dignità nella sofferenza. Cerca volti che raccontano storie di resilienza — non vittime, ma persone.',
    corpo: 'Relazionale. Prima la connessione umana, poi il click. Parlava con i suoi soggetti, si sedeva con loro.',
    macchina: '50mm. f/4 o f/5.6 per isolare il volto. Tempo 1/250s. Focus critico sull\'occhio più vicino.',
    iphone: {
      lente: '2x (48mm)',
      modo: 'Portrait mode • Sfocatura MEDIA (f/4.5)',
      esposizione: 'Auto',
      focus: 'Tocca sull\'OCCHIO più vicino',
      editing: 'B/N • Contrasto medio • Ombre aperte • Nitidezza occhi +25',
      tip: 'PRIMA parla, DOPO scatta. Siediti al loro livello. Aspetta lo sguardo diretto.'
    },
    esempio: 'Una donna seduta davanti a una tenda. Quando il suo sguardo incrocia il tuo con quella miscela di preoccupazione e determinazione, scatti.',
    settings: { aperture: 'f/4-5.6', shutter: '1/250s', iso: '100-400', focal: '50mm' },
    simSettings: { aperture: 4, shutter: 125, iso: 200 },
    simRationale: 'f/4 isola il volto dallo sfondo — solo la persona conta, il contesto sfuma.',
    missione: '🎯 Oggi: Trova qualcuno che lavora con le mani. Avvicinati, presenta te stesso, chiedi se puoi fotografarlo. Aspetta lo sguardo che racconta la fatica e la dignità insieme.'
  },
  {
    id: 'steve-mccurry',
    nome: 'Steve McCurry',
    titolo: 'L\'Anima nel Colore',
    scuola: 'Sentimento e Umano',
    tipo: 'color',
    occhio: 'Il contatto visivo come ponte tra mondi. Cerca occhi che parlano — colori saturi, sfondi semplificati.',
    corpo: 'Paziente e rispettoso. Aspetta il contatto visivo. Non rubi l\'immagine — la ricevi.',
    macchina: '35mm o 50mm. Compensazione esposizione -0.7 EV per saturare i colori. Profilo "Vivid".',
    iphone: {
      lente: '2x (48mm)',
      modo: 'Portrait mode • Sfocatura media',
      esposizione: 'Trascina GIÙ -0.5 EV per saturare i colori',
      focus: 'Tocca sugli OCCHI — sempre',
      editing: 'Vibrance +20 • Contrasto +10 • Chiarezza occhi +15',
      tip: 'Aspetta il CONTATTO VISIVO. Cerca sfondi monocolore saturi (muro blu, tenda rossa).'
    },
    esempio: 'Un mercato in India. Una ragazza ti guarda. Quando i suoi occhi incontrano i tuoi con curiosità e fierezza, scatti.',
    settings: { aperture: 'f/2.8-4', shutter: '1/250s', iso: '100-400', focal: '35-50mm' },
    simSettings: { aperture: 2.8, shutter: 250, iso: 200 },
    simRationale: 'f/2.8 sfoca lo sfondo — gli occhi emergono dal caos del mercato. Il colore è emozione.',
    missione: '🎯 Oggi: Vai dove c\'è gente — mercato, stazione, piazza. Cerca occhi che ti guardano. Quando incroci uno sguardo interessante, alza la camera e scatta subito. Sfondo sfocato, colori saturi.'
  },
  {
    id: 'sebastiao-salgado',
    nome: 'Sebastião Salgado',
    titolo: 'L\'Epica Sociale',
    scuola: 'Sentimento e Umano',
    tipo: 'bw',
    occhio: 'La monumentalità dell\'umano. Scene dove lavoro e fatica diventano composizioni quasi bibliche. Corpi come sculture.',
    corpo: 'Paziente. Ti guadagni il diritto di essere lì — a volte per settimane. Aspetti che la scena si componga.',
    macchina: '28mm o 35mm grandangolo. f/11. Misurazione Spot sulle alte luci. Esponi per le luci.',
    iphone: {
      lente: '0.5x (13mm) per scene epiche • 1x per intime',
      modo: 'Photo standard — NO Portrait',
      esposizione: 'Tocca sulle ALTE LUCI (cielo) — ombre in nero profondo',
      focus: 'Non toccare — tutto a fuoco',
      editing: 'B/N • Neri +50 • Contrasto alto • Curve S aggressiva • Nitidezza +30',
      tip: 'CONTROLUCE obbligatorio. Sole DIETRO i soggetti. Cerca pattern di figure che si ripetono.'
    },
    esempio: 'Una miniera d\'oro. Centinaia di uomini. Aspetti che tre figure si allineino in diagonale, la luce le incorona controluce.',
    settings: { aperture: 'f/11', shutter: '1/250s', iso: '100-400', focal: '28-35mm' },
    simSettings: { aperture: 11, shutter: 8, iso: 100 },
    simRationale: 'f/11 per profondità totale — ogni figura conta, dal primo piano all\'infinito. ISO 100 per neri epici.',
    missione: '🎯 Oggi: Trova un luogo con molte persone in movimento — cantiere, stazione, evento. Cerca il momento in cui 3+ figure si allineano in una diagonale. Converti in B/N drammatico.'
  },
  
  // SCUOLA 3: ASTRAZIONE E CAOS
  {
    id: 'saul-leiter',
    nome: 'Saul Leiter',
    titolo: 'La Poesia dell\'Astrazione',
    scuola: 'Astrazione e Caos',
    tipo: 'color',
    occhio: 'Non il soggetto — l\'ostacolo davanti al soggetto. Vetri appannati, riflessi, ombrelli. Colori che sanguinano.',
    corpo: 'Statico, al riparo. Guarda da dentro verso fuori: caffè, taxi, portoni. L\'ostacolo diventa il soggetto.',
    macchina: '50mm o più lungo. f/2.8 o f/4 per sfocature morbide. Compensazione -1.3 EV per colori densi.',
    iphone: {
      lente: '2x (48mm) o 3x',
      modo: 'Photo standard — Portrait mode OFF',
      esposizione: 'Trascina GIÙ -1 EV per colori densi',
      focus: 'Non importa — la sfocatura è intenzionale',
      editing: 'Saturazione rossi/gialli +20 • Contrasto -10 • WB caldo 7000K • Ombre dense',
      tip: 'Scatta ATTRAVERSO: vetri appannati, gocce, riflessi, tende. L\'ostacolo È il soggetto.'
    },
    esempio: 'Piove. Vetrina appannata. Fuori passa una figura con ombrello rosso. Scatti attraverso la condensa. Il rosso diventa macchia.',
    settings: { aperture: 'f/2.8-4', shutter: '1/60s', iso: '200-800', focal: '50mm+' },
    simSettings: { aperture: 2.8, shutter: 500, iso: 400 },
    simRationale: 'f/2.8 crea sfocature pittoriche — il mondo diventa acquerello, i colori sanguinano.',
    missione: '🎯 Oggi: Aspetta la pioggia o trova una vetrina. Scatta ATTRAVERSO il vetro appannato/bagnato. Cerca macchie di colore (ombrelli rossi, insegne). Sfocato intenzionale.'
  },
  {
    id: 'alex-webb',
    nome: 'Alex Webb',
    titolo: 'La Stratificazione',
    scuola: 'Astrazione e Caos',
    tipo: 'color',
    occhio: 'Complessità organizzata. Riempi ogni angolo con strati di colore, figure, ombre — equilibrio impossibile.',
    corpo: 'Architetto del caos. Ti muovi nel mezzo della scena. Costruisci il frame piano dopo piano.',
    macchina: '28mm o 35mm. f/11 o f/16 per profondità totale. ISO alti (800+). Sottoesposizione -0.3 EV.',
    iphone: {
      lente: '0.5x (13mm) o 1x (24mm)',
      modo: 'Photo standard — Portrait mode MAI',
      esposizione: 'Trascina GIÙ -0.3 EV',
      focus: 'Non toccare — TUTTO deve essere a fuoco',
      editing: 'Saturazione +15 • Contrasto +10 • Ombre +20 • Colori vividi',
      tip: 'Sole forte, ombre dure. Costruisci 3+ strati: sfondo colorato + medio + primo piano. Aspetta l\'allineamento.'
    },
    esempio: 'Un vicolo caraibico. Muro azzurro, ombra di palma, bambino in rosso, donna in giallo, bicicletta. Cinque elementi allineati.',
    settings: { aperture: 'f/11-16', shutter: '1/250s', iso: '800+', focal: '28-35mm' },
    simSettings: { aperture: 16, shutter: 30, iso: 800 },
    simRationale: 'f/16 per nitidezza su TUTTI i piani — ogni strato deve essere leggibile, niente sfocature.',
    missione: '🎯 Oggi: Cerca un angolo colorato — muro dipinto, mercato, quartiere vivace. Aspetta che si sovrappongano almeno 4 elementi: persona, ombra, colore, oggetto. Tutto a fuoco, colori saturi.'
  },
  {
    id: 'robert-frank',
    nome: 'Robert Frank',
    titolo: 'L\'Estetica del Caos',
    scuola: 'Astrazione e Caos',
    tipo: 'bw',
    occhio: 'L\'imperfezione come verità. Grana, mosso, orizzonti storti — tutto è permesso se cattura qualcosa di vero.',
    corpo: 'Dirompente e istintivo. Scatti d\'istinto senza mediazioni. La fotocamera è un\'estensione del tuo nervosismo.',
    macchina: '35mm. Tempo fisso a 1/60s (accetta il mosso). Focus manuale istintivo. Orizzonte libero.',
    iphone: {
      lente: '1x (24mm)',
      modo: 'Photo standard',
      esposizione: 'Non toccare — accetta quello che viene',
      focus: 'Non toccare',
      editing: 'B/N • Contrasto medio • Grana +60 • NON raddrizzare • NON nitidizzare',
      tip: 'Scatta MENTRE cammini. Accetta mosso, storto, tagliato. L\'imperfezione È autenticità.'
    },
    esempio: 'Una strada americana di notte. Jukebox, neon. Scatti mentre cammini. Il mosso dice "ero lì, è successo".',
    settings: { aperture: 'f/4-5.6', shutter: '1/60s', iso: '400-1600', focal: '35mm' },
    simSettings: { aperture: 4, shutter: 500, iso: 800 },
    simRationale: '1/500s congela il caos urbano — ISO alto per grana nervosa che aggiunge energia.',
    missione: '🎯 Oggi: Cammina per 1 ora senza fermarti. Scatta mentre cammini, senza guardare lo schermo. Accetta il mosso, la grana, l\'inquadratura storta. Cerca l\'anima del luogo, non la perfezione.'
  },
  
  // SCUOLA 4: TECNICA PURA
  {
    id: 'ansel-adams',
    nome: 'Ansel Adams',
    titolo: 'Il Sistema Zonale Digitale',
    scuola: 'Tecnica Pura',
    tipo: 'bw',
    occhio: 'La gamma tonale completa, dalle ombre più profonde alle luci più alte. Fotografa la luce sulla natura.',
    corpo: 'Contemplativo e tecnico. Aspetti la luce giusta — ore, giorni. Ogni scatto è pianificato.',
    macchina: 'Misurazione Spot. Esponi sulle alte luci +2 stop (ETTR). Recuperi le ombre in post.',
    iphone: {
      lente: '0.5x paesaggi vasti • 1x composizioni strette',
      modo: 'ProRAW OBBLIGATORIO • Cavalletto',
      esposizione: 'Tocca sulla parte PIÙ LUMINOSA (nuvola, cielo)',
      focus: 'Non toccare',
      editing: 'Ombre +100 • Alte luci -50 • Bianchi al limite • Neri al nero puro • Chiarezza +30 • B/N con mix canali',
      tip: 'Aspetta la luce giusta. Alba/tramonto o temporali. Ogni tono dal nero al bianco deve essere presente.'
    },
    esempio: 'Una valle montana. Nuvole temporalesche. Misuri la nuvola brillante, sovraesponi. In post riporti le ombre.',
    settings: { aperture: 'f/11-16', shutter: 'Varia', iso: '100', focal: 'Varia' },
    simSettings: { aperture: 11, shutter: 8, iso: 100 },
    simRationale: 'ISO 100 per massima gamma dinamica. f/11 per nitidezza da primo piano a infinito.',
    missione: '🎯 Oggi: Svegliati all\'alba o esci al tramonto. Trova un paesaggio con primo piano interessante + sfondo + cielo. Esponi per le alte luci, recupera le ombre in editing. Tutto nitidissimo.'
  },
  {
    id: 'peter-lindbergh',
    nome: 'Peter Lindbergh',
    titolo: 'Il Ritratto Cinematografico',
    scuola: 'Tecnica Pura',
    tipo: 'bw',
    occhio: 'La verità del volto senza filtri. Rughe, imperfezioni, carattere. La bellezza è autenticità.',
    corpo: 'Collaborativo, mai dominante. Il soggetto deve dimenticare la fotocamera. Luce naturale, mai flash.',
    macchina: '85mm. f/2.8 per separare dal sfondo. Contrasto alto, luci morbide. Niente sorrisi forzati.',
    iphone: {
      lente: '2x (48mm) o 3x',
      modo: 'Portrait mode • Sfocatura MEDIA',
      esposizione: 'Auto',
      focus: 'Tocca sull\'OCCHIO illuminato',
      editing: 'B/N • Contrasto deciso • Chiarezza +20 • Vignetta leggera • ZERO ritocco pelle',
      tip: 'Luce FINESTRA laterale a 45°. Chiedi di PENSARE, non sorridere. Le imperfezioni restano.'
    },
    esempio: 'Una modella senza trucco, capelli al vento. Non sorridere — pensare a qualcosa di vero. Le imperfezioni restano.',
    settings: { aperture: 'f/2.8', shutter: '1/125s', iso: '100-400', focal: '85mm' },
    simSettings: { aperture: 2.8, shutter: 250, iso: 200 },
    simRationale: 'f/2.8 separa il volto dallo sfondo — sfocatura cremosa, solo gli occhi a fuoco.',
    missione: '🎯 Oggi: Chiedi a qualcuno un ritratto. Luce naturale da finestra, niente flash. Digli di NON sorridere, di pensare a qualcosa di vero. Converti in B/N, lascia le imperfezioni.'
  },
  
  // SCUOLA 5: PROSPETTIVA INUSUALE
  {
    id: 'vivian-maier',
    nome: 'Vivian Maier',
    titolo: 'La Prospettiva dal Basso',
    scuola: 'Prospettiva Inusuale',
    tipo: 'bw',
    occhio: 'La vita quotidiana da un\'angolazione inaspettata. Momenti ordinari visti dal basso, monumentali e intimi.',
    corpo: 'Discreto, invisibile. Macchina al petto, sguardo apparentemente altrove. Nessuno sa che li stai fotografando.',
    macchina: 'Rolleiflex 1:1 (quadrato). f/8. Monitor basculante per comporre dal petto.',
    iphone: {
      lente: '1x (24mm)',
      modo: 'Photo • Formato 1:1 (quadrato)',
      esposizione: 'Auto',
      focus: 'Non toccare',
      editing: 'B/N • Contrasto medio • Crop per composizione',
      tip: 'iPhone AL PETTO, guarda schermo dall\'alto. Scatta col tasto volume. MAI alzare al viso. Fingi di controllare messaggi.'
    },
    esempio: 'Un bambino ti guarda — ma non in camera, perché la camera è al petto. Occhi sopra l\'obiettivo. Più vero.',
    settings: { aperture: 'f/8', shutter: '1/125s', iso: '400', focal: '35mm eq.' },
    simSettings: { aperture: 8, shutter: 60, iso: 400 },
    simRationale: 'f/8 per iperfocale discreta — fuoco da 2m a infinito senza bisogno di mettere a fuoco.',
    missione: '🎯 Oggi: Tieni il telefono al petto, schermo verso l\'alto. Scatta senza portarlo all\'occhio. Cerca riflessi in vetrine dove appari anche tu. Formato quadrato. Nessuno deve accorgersi.'
  },
  {
    id: 'william-eggleston',
    nome: 'William Eggleston',
    titolo: 'Il Colore del Banale',
    scuola: 'Prospettiva Inusuale',
    tipo: 'color',
    occhio: 'La nobilitazione dell\'ordinario. Oggetti quotidiani trattati come monumenti. Il colore saturo trasforma.',
    corpo: 'Democratico. Inquadrature dal basso, angoli "scomode". Non c\'è soggetto principale — tutto ha dignità.',
    macchina: '35mm. Saturazione alta. Inquadrature dal basso o angoli inaspettati.',
    iphone: {
      lente: '1x (24mm) • 0.5x per soffitti',
      modo: 'Photo standard',
      esposizione: 'Auto',
      focus: 'Non toccare',
      editing: 'Saturazione +25 • Vibrance +20 • Rossi e gialli esplodono • Contrasto medio',
      tip: 'DAL BASSO verso l\'alto. Fotografa IL BANALE: parcheggi, soffitti, carrelli, lampioni. Niente è insignificante.'
    },
    esempio: 'Un parcheggio vuoto al tramonto. Un carrello abbandonato. Dal basso verso l\'alto. Il banale diventa epico.',
    settings: { aperture: 'f/5.6-8', shutter: '1/125s', iso: '100-400', focal: '35mm' },
    simSettings: { aperture: 5.6, shutter: 60, iso: 200 },
    simRationale: 'f/5.6 — abbastanza nitido per i dettagli banali, abbastanza aperto per luce morbida.',
    missione: '🎯 Oggi: Fotografa 10 cose che normalmente ignoreresti — un carrello, un muro scrostato, un\'insegna. Sdraiati per terra, scatta dal basso. Il banale diventa monumento. Colori saturi.'
  }
];
// ============================================
// DATA: SCENARI (REFLEX + IPHONE)
// ============================================
const SCENARI = [
  {
    id: 'fuochi',
    nome: '🎆 Fuochi d\'Artificio',
    reflex: { shutter: '2-4s', aperture: 'f/8-11', iso: '100-200', note: 'Cavalletto obbligatorio. Scatto remoto.' },
    iphone: {
      lente: '1x (24mm) o 0.5x (13mm) per includere contesto',
      formato: 'ProRAW Max 48MP — massimo dettaglio per recuperare alte luci',
      modo: 'Photo standard — evita Night Mode che sfoca le scie',
      camControl: 'Half-press per bloccare focus su infinito PRIMA che inizino',
      esposizione: 'Tocca sul cielo scuro, trascina EV a -1.0. Le esplosioni sono luminose.',
      style: 'Standard — nessuno style, serve flessibilità in post',
      editing: 'Alte luci -50, Neri +30, Vibrance +20. Crop su esplosione migliore.',
      tip: 'CAVALLETTO OBBLIGATORIO. Usa AirPods come remote (iOS 26): premi stem per scattare senza toccare. Timer 3s se no remote.'
    },
    maestriRef: ['ansel-adams']
  },
  {
    id: 'ritratto',
    nome: '👤 Ritratto',
    reflex: { shutter: '1/125s+', aperture: 'f/1.8-2.8', iso: 'Auto', note: 'Focus sull\'occhio più vicino.' },
    iphone: {
      lente: '2x (48mm) per ritratti classici — compressione flattering. 5x (120mm) per ritratti stretti/dettagli.',
      formato: 'HEIF per usare Photographic Styles in post. ProRAW se vuoi controllo totale.',
      modo: 'Portrait Mode — sfocatura regolabile da f/1.4 a f/16 in post',
      camControl: 'Imposta su "Depth" per regolare sfocatura live. Half-press blocca focus sugli occhi.',
      esposizione: 'Tocca sugli OCCHI per focus+esposizione. Se viso scuro, trascina EV +0.3/+0.5.',
      style: 'Natural o Rich Contrast. Evita Vibrant sui volti (pelle innaturale).',
      editing: 'In Foto: regola Depth dopo. Brilliance +10, Ombre +20. Occhi: Nitidezza locale +15.',
      tip: 'Golden hour o luce finestra laterale. MAI sole diretto su viso. iPhone riconosce volti automaticamente — anche in Photo mode salva dati Portrait.'
    },
    maestriRef: ['peter-lindbergh', 'dorothea-lange', 'steve-mccurry']
  },
  {
    id: 'sport',
    nome: '⚽ Sport / Azione',
    reflex: { shutter: '1/500s+', aperture: 'f/2.8-4', iso: 'Auto (alto)', note: 'Scatto continuo. AI Servo/AF-C.' },
    iphone: {
      lente: '2x (48mm) per azione media distanza. 5x (120mm) per azione lontana — ma AF più lento.',
      formato: 'HEIF — Burst mode NON funziona con ProRAW',
      modo: 'Photo + Burst: tieni premuto shutter e scorri a SINISTRA',
      camControl: 'Click singolo per scatto rapido. NON usare per burst — usa shutter touch.',
      esposizione: 'Auto. Se controluce, pre-blocca AE/AF su zona simile prima dell\'azione.',
      style: 'Vibrant per colori saturi in condizioni di luce mista (stadi)',
      editing: 'Seleziona i frame migliori dal burst. Crop per composizione. Nitidezza +25.',
      tip: 'ANTICIPA il momento — c\'è lag. Action Mode (Video) stabilizza ma riduce risoluzione. Per foto: Burst + luce forte. Evita 5x per soggetti veloci vicini.'
    },
    maestriRef: ['cartier-bresson']
  },
  {
    id: 'cascata',
    nome: '💧 Cascata / Acqua Setosa',
    reflex: { shutter: '1-5s', aperture: 'f/16-22', iso: '100', note: 'Cavalletto. Filtro ND se luce forte.' },
    iphone: {
      lente: '0.5x (13mm) per cascate + contesto. 1x (24mm) per dettaglio acqua.',
      formato: 'HEIF — serve Live Photo attiva',
      modo: 'Photo con LIVE PHOTO attiva (cerchio giallo). In post: seleziona "Esposizione Lunga".',
      camControl: 'Non usare — Live Photo richiede shutter normale',
      esposizione: 'Tocca sulle rocce/vegetazione (mezzitoni). Acqua bianca si gestisce in post.',
      style: 'Natural — effetto seta viene da Live Photo, non da style',
      editing: 'In Foto → Live Photo → Esposizione Lunga. Poi: Contrasto +15, Neri +20, Saturazione +10.',
      tip: 'Tieni iPhone FERMO per 3 secondi dopo lo scatto — Live Photo cattura prima/dopo. Cavalletto o appoggio solido obbligatorio per effetto seta pulito.'
    },
    maestriRef: ['ansel-adams']
  },
  {
    id: 'vialattea',
    nome: '🌌 Via Lattea',
    reflex: { shutter: '15-25s', aperture: 'f/1.8-2.8', iso: '3200-6400', note: 'Regola 500. Cavalletto. No luna.' },
    iphone: {
      lente: '0.5x (13mm) f/2.2 — campo più ampio per Via Lattea + paesaggio. 1x (24mm) se vuoi meno distorsione.',
      formato: 'ProRAW Max 48MP — ESSENZIALE per recuperare dettaglio stelle e ridurre rumore in post',
      modo: 'Night Mode automatica. Quando rileva buio totale, offre fino a 30s.',
      camControl: 'Half-press blocca focus su infinito. Non toccare più.',
      esposizione: 'Lascia che Night Mode gestisca. Se stelle "bruciate", EV -0.5.',
      style: 'Nessuno — in RAW li applichi dopo',
      editing: 'Lightroom/Snapseed: Alte luci -100, Ombre +60, Temp più fredda (più blu), Dehaze +30, Riduzione rumore.',
      tip: 'CAVALLETTO STABILE obbligatorio. Zero inquinamento luminoso. No luna. App PhotoPills per posizione Via Lattea. Usa AirPods come remote. Aspetta adattamento occhi 20min.'
    },
    maestriRef: ['ansel-adams']
  },
  {
    id: 'tramonto',
    nome: '🌅 Tramonto / Alba',
    reflex: { shutter: '1/250s', aperture: 'f/8-11', iso: '100-200', note: 'Sottoesponi -0.7 EV per saturare.' },
    iphone: {
      lente: '0.5x (13mm) per cielo drammatico ampio. 1x (24mm) standard. 5x (120mm) per sole grande.',
      formato: 'ProRAW Max — gamma dinamica difficile, serve flessibilità',
      modo: 'Photo standard. HDR automatico aiuta ma a volte appiattisce.',
      camControl: 'Imposta default su "Exposure". Slide giù per sottoesporre (-0.5 a -1.0).',
      esposizione: 'TOCCA SUL CIELO (non sul sole). Trascina EV a -0.5/-0.7. Colori più saturi.',
      style: 'Vibrant per boost automatico. O Standard + editing manuale.',
      editing: 'Alte luci -40, Ombre +30 (per primo piano), Temp +10 (più caldo), Saturazione +15.',
      tip: 'Arriva 30min PRIMA. I colori migliori sono 10-15min dopo il tramonto (blue hour). Silhouette: esponi sul cielo, soggetto diventa nero.'
    },
    maestriRef: ['ansel-adams', 'sebastiao-salgado']
  },
  {
    id: 'notturna',
    nome: '🌃 Street Notturna',
    reflex: { shutter: '1/60s', aperture: 'f/1.8-2.8', iso: '1600-6400', note: 'Accetta la grana. Appoggia se serve.' },
    iphone: {
      lente: '1x (24mm) f/1.78 — sensore grande, più luce. Evita 5x di notte (sensore piccolo, molto rumore).',
      formato: 'ProRAW per controllo rumore in post. HEIF se vuoi Night Mode processing.',
      modo: 'Night Mode auto (1-3s handheld). Per scene statiche, appoggia e lascia 5-10s.',
      camControl: 'Half-press per bloccare AE/AF su zona illuminata (insegne, lampioni).',
      esposizione: 'Tocca su zona MID (non le luci brillanti). Night Mode bilancia.',
      style: 'Rich Contrast per neri profondi e luci che "bucano".',
      editing: 'Neri +30, Alte luci -20, Clarity +15. Grana aggiunta per look film.',
      tip: 'APPOGGIA iPhone su qualcosa per Night Mode lunghe. Insegne al neon = tocca SOTTO l\'insegna per non sovraesporre. Accetta il rumore — è atmosfera.'
    },
    maestriRef: ['saul-leiter', 'robert-frank', 'ara-guler']
  },
  {
    id: 'macro',
    nome: '🔍 Macro',
    reflex: { shutter: '1/250s+', aperture: 'f/8-11', iso: 'Auto', note: 'Focus stacking per profondità. Cavalletto.' },
    iphone: {
      lente: 'Ultra-wide 0.5x (13mm) — si attiva AUTOMATICAMENTE sotto ~2cm. Icona fiore giallo.',
      formato: 'ProRAW Max 48MP — ultra-wide ora è 48MP, massimo dettaglio',
      modo: 'Photo standard. Macro Control ON in Settings per override manuale.',
      camControl: 'Non ideale per macro — meglio touch per precisione focus.',
      esposizione: 'Tocca sul soggetto. Se troppo scuro (ombra tua), EV +0.5.',
      style: 'Natural per colori accurati. Vibrant per fiori/insetti.',
      editing: 'Nitidezza +30, Clarity +20, Saturazione +10. Crop su dettaglio interessante.',
      tip: 'LUCE LATERALE per texture. Attento all\'ombra della tua mano/telefono. Avvicinati LENTAMENTE — il focus macro è critico. Scatta multipli, la profondità di campo è millimetrica.'
    },
    maestriRef: ['william-eggleston']
  },
  {
    id: 'architettura',
    nome: '🏛️ Architettura',
    reflex: { shutter: '1/125s', aperture: 'f/8-11', iso: '100-400', note: 'Tilt-shift o correggi prospettiva in post.' },
    iphone: {
      lente: '0.5x (13mm) per edifici interi/interni. 1x (24mm) per dettagli. ATTIVA Lens Correction in Settings.',
      formato: 'ProRAW Max — per correzione prospettiva serve risoluzione',
      modo: 'Photo standard. Grid + Level SEMPRE attivi.',
      camControl: 'Non necessario — scene statiche.',
      esposizione: 'Auto o tocca su facciata principale. Cielo può sovraesporre — ok.',
      style: 'Standard per flessibilità. O Natural per look neutro.',
      editing: 'PROSPETTIVA: usa strumento Verticale/Orizzontale in Foto o Lightroom. Poi: Contrasto +10, Clarity +20.',
      tip: 'PERPENDICOLARE alla facciata elimina distorsione. Allinea linee verticali con la griglia. Golden hour per luce calda su edifici. Blue hour per luci interne accese.'
    },
    maestriRef: ['wes-anderson', 'fan-ho']
  },
  {
    id: 'food',
    nome: '🍕 Food',
    reflex: { shutter: '1/125s', aperture: 'f/2.8-4', iso: '100-800', note: 'Luce finestra a 45°. Sfondo sfocato.' },
    iphone: {
      lente: '2x (48mm) per piatti singoli — compressione evita distorsione bordi. 1x per tavola intera.',
      formato: 'HEIF — Photographic Styles funzionano bene qui',
      modo: 'Portrait Mode con f/2.8-f/4 per sfondo sfocato elegante.',
      camControl: 'Imposta su "Depth" per regolare sfocatura live.',
      esposizione: 'Tocca sul piatto. Se piatto bianco, EV +0.3 per evitare grigio.',
      style: 'Vibrant per colori appetitosi. O Warm per atmosfera ristorante.',
      editing: 'Temp leggermente calda (+5), Saturazione +10, Ombre +15 per dettaglio.',
      tip: 'LUCE FINESTRA a 45° — mai flash. Angoli: 45° per piatti con altezza, 90° (zenitale) per piatti piatti. Sfondo scuro/legno. Sposta il piatto VERSO la luce, non la camera.'
    },
    maestriRef: ['william-eggleston']
  },
  {
    id: 'concerto',
    nome: '🎸 Concerto',
    reflex: { shutter: '1/250s+', aperture: 'f/2.8', iso: '3200-12800', note: 'Spot sui volti. Accetta grana.' },
    iphone: {
      lente: '1x (24mm) o 2x (48mm). EVITA 5x — troppo buio, rumore estremo.',
      formato: 'HEIF — ProRAW non gestisce bene luci colorate estreme',
      modo: 'Photo standard. Night Mode si attiva ma può sfocare movimento.',
      camControl: 'Half-press TIENI PREMUTO per bloccare AE/AF sul volto artista.',
      esposizione: 'BLOCCA su viso (tieni premuto finché vedi AE/AF Lock). Le luci cambiano continuamente.',
      style: 'Rich Contrast per luci che "bucano" il nero. O Standard.',
      editing: 'Alte luci -30, Neri +20, Saturazione selettiva sui colori luci. Accetta rumore.',
      tip: 'EVITA zoom digitale — croppare dopo è meglio. Scatta TANTO — 1 su 20 sarà buona. Momenti: picco canzone, braccia alzate, spotlight singolo.'
    },
    maestriRef: ['robert-frank', 'ara-guler']
  },
  {
    id: 'animali',
    nome: '🐕 Animali Domestici',
    reflex: { shutter: '1/500s+', aperture: 'f/2.8-4', iso: 'Auto', note: 'Eye-AF animali. Scatto continuo.' },
    iphone: {
      lente: '1x (24mm) per cani grandi/azione. 2x (48mm) per ritratti animali. 5x per animali timidi.',
      formato: 'HEIF — Burst non funziona con ProRAW',
      modo: 'Photo + Portrait Mode (riconosce cani e gatti per sfocatura automatica)',
      camControl: 'Click rapido per scatto istantaneo. Per burst: shutter touch.',
      esposizione: 'Tocca sugli OCCHI dell\'animale. iPhone rileva automaticamente.',
      style: 'Natural o Vibrant per pelo lucido.',
      editing: 'Nitidezza occhi +20, Pelo: Clarity +15. Sfondo: vignetta leggera.',
      tip: 'ABBASSATI al loro livello — prospettiva occhi. Luce forte per tempi veloci. Suoni/giochi per attenzione. Burst per momenti azione. Portrait mode funziona anche su animali.'
    },
    maestriRef: ['steve-mccurry']
  },
  {
    id: 'street',
    nome: '🚶 Street',
    reflex: { shutter: '1/250s', aperture: 'f/8', iso: 'Auto', note: 'Fuoco iperfocale 3m. Non pensare, reagisci.' },
    iphone: {
      lente: '1x (24mm) default street. 1.5x (35mm) per classico. 2x (48mm) per isolare.',
      formato: 'HEIF per velocità. ProRAW se tempo per comporre.',
      modo: 'Photo standard. NO Portrait — serve tutto a fuoco.',
      camControl: 'IMPOSTA DEFAULT SU "Cameras" — swipe veloce tra focali.',
      esposizione: 'Pre-imposta EV -0.3 (Preserve Settings ON). Street spesso sovraespone.',
      style: 'Rich Contrast per B/N conversion. O Natural.',
      editing: 'B/N: Contrasto +20, Clarity +15. Colore: desatura leggermente.',
      tip: 'NON inquadrare — reagisci. Scatta largo, croppa dopo. Camera all\'altezza del petto, schermo inclinato verso l\'alto. Nessuno se ne accorge. Settings → Preserve Settings → tutto ON.'
    },
    maestriRef: ['cartier-bresson', 'vivian-maier', 'robert-frank']
  },
  {
    id: 'pioggia',
    nome: '🌧️ Pioggia / Riflessi',
    reflex: { shutter: '1/125s', aperture: 'f/4-5.6', iso: '400-800', note: 'Proteggi gear. Esponi sulle luci.' },
    iphone: {
      lente: '1x (24mm) o 2x (48mm) per riflessi stretti su asfalto.',
      formato: 'HEIF — Photographic Styles aiutano l\'atmosfera',
      modo: 'Photo standard. Night Mode per pioggia serale.',
      camControl: 'Exposure control per bilanciare riflessi luminosi.',
      esposizione: 'Tocca sui RIFLESSI delle luci (non le luci dirette). EV -0.3.',
      style: 'Muted per atmosfera malinconica. Warm per riflessi dorati.',
      editing: 'Clarity +20 per texture bagnato, Dehaze -10 (più foschia), Saturazione selettiva su riflessi colorati.',
      tip: 'SCATTA ATTRAVERSO vetrine/finestrini — sfocato davanti crea layers. Riflessi migliori su asfalto scuro. Ombrelli colorati = soggetto. Proteggi iPhone con mano/borsa, resiste schizzi ma non pioggia diretta.'
    },
    maestriRef: ['saul-leiter']
  },
  {
    id: 'silhouette',
    nome: '🌄 Silhouette',
    reflex: { shutter: '1/250s+', aperture: 'f/8-11', iso: '100', note: 'Esponi sul cielo. Soggetto nero.' },
    iphone: {
      lente: '1x (24mm) o 0.5x (13mm) per figura + cielo ampio. 5x (120mm) per silhouette isolata.',
      formato: 'HEIF o ProRAW — entrambi funzionano',
      modo: 'Photo standard. DISATTIVA Smart HDR se possibile (appiattisce silhouette).',
      camControl: 'Exposure: slide DOWN forte (-1.5 a -2.0) dopo aver toccato cielo.',
      esposizione: 'TOCCA SUL CIELO luminoso. Trascina esposizione GIÙ finché soggetto è nero puro.',
      style: 'Rich Contrast — aumenta separazione cielo/soggetto',
      editing: 'Neri +50, Alte luci -30, Contrasto +25. Silhouette deve essere NERA, non grigia.',
      tip: 'Soggetto DAVANTI a fonte luce (sole, finestra, lampione). Profilo riconoscibile (persona di lato, albero). Se silhouette grigia, sottoesponi ancora in editing.'
    },
    maestriRef: ['fan-ho', 'sebastiao-salgado']
  }
];
// ============================================
// DATA: COMPOSIZIONE
// ============================================
const COMPOSIZIONE = [
  { nome: 'Regola dei Terzi', desc: 'Soggetto sulle intersezioni della griglia 3x3' },
  { nome: 'Linee Guida', desc: 'Usa strade, binari, fiumi per guidare l\'occhio' },
  { nome: 'Cornici Naturali', desc: 'Porte, finestre, archi per incorniciare il soggetto' },
  { nome: 'Spazio Negativo', desc: 'Lascia "respiro" intorno al soggetto' },
  { nome: 'Riempire il Frame', desc: 'Avvicinati, elimina distrazioni' },
  { nome: 'Simmetria', desc: 'Riflessi, architetture, pattern' },
  { nome: 'Pattern e Rottura', desc: 'Ripetizioni con un elemento diverso' },
  { nome: 'Diagonali', desc: 'Linee oblique creano dinamismo' },
  { nome: 'Punto di Vista', desc: 'Cambia altezza: dal basso, dall\'alto' },
  { nome: 'Primo Piano', desc: 'Elemento vicino per profondità' },
  { nome: 'Triangoli', desc: 'Tre elementi in equilibrio dinamico' },
  { nome: 'Sezione Aurea', desc: 'Spirale naturale, più fluida dei terzi' },
  { nome: 'Minimalismo', desc: 'Un solo soggetto, sfondo pulito' },
  { nome: 'Contrasto', desc: 'Grande/piccolo, chiaro/scuro, vecchio/nuovo' },
  { nome: 'Momento', desc: 'L\'espressione, il gesto, l\'istante giusto' }
];
// ============================================
// STYLES
// ============================================
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Source+Sans+3:wght@300;400;500;600&display=swap');
  
  * { box-sizing: border-box; margin: 0; padding: 0; }
  
  :root {
    --bg-primary: #0a0a0f;
    --bg-secondary: #12121a;
    --bg-card: #1a1a24;
    --bg-card-hover: #22222e;
    --text-primary: #f5f5f7;
    --text-secondary: #a0a0a8;
    --text-muted: #6b6b75;
    --accent: #d4a574;
    --accent-dim: rgba(212, 165, 116, 0.15);
    --success: #4ade80;
    --warning: #fbbf24;
    --danger: #f87171;
    --border: rgba(255,255,255,0.08);
    color-scheme: dark;
  }
  
  * {
    color-scheme: dark;
  }
  
  body {
    font-family: 'Source Sans 3', -apple-system, sans-serif;
    background: var(--bg-primary) !important;
    color: var(--text-primary) !important;
    line-height: 1.6;
    min-height: 100vh;
  }
  
  .app {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 80px;
  }
  
  /* Header */
  .header {
    text-align: center;
    padding: 3rem 1.5rem 2rem;
    border-bottom: 1px solid var(--border);
  }
  
  .header h1 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(2rem, 5vw, 3rem);
    font-weight: 600;
    margin-bottom: 0.25rem;
    background: linear-gradient(135deg, var(--text-primary), var(--accent));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .header .subtitle {
    font-size: 1.1rem;
    color: var(--text-muted);
    margin: 0;
    font-style: italic;
    letter-spacing: 0.02em;
  }
  
  .header p {
    color: var(--text-secondary);
    font-size: 1.1rem;
  }
  
  /* Navigation */
  .nav {
    display: flex;
    gap: 0.25rem;
    padding: 1rem;
    background: var(--bg-secondary);
    position: sticky;
    top: 0;
    z-index: 100;
    overflow-x: auto;
    border-bottom: 1px solid var(--border);
  }
  
  .nav-btn {
    flex: 1;
    min-width: max-content;
    padding: 0.75rem 1rem;
    background: transparent;
    border: none;
    color: var(--text-secondary);
    font-size: 0.9rem;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
  }
  
  .nav-btn:hover { background: var(--bg-card); color: var(--text-primary); }
  .nav-btn.active { background: var(--accent-dim); color: var(--accent); }
  .nav-btn span { font-size: 1.2rem; }
  
  /* Sections */
  .section {
    padding: 2rem 1.5rem;
  }
  
  .section-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.75rem;
    margin-bottom: 1.5rem;
    color: var(--text-primary);
  }
  
  /* ============================================
     SIMULATOR - ENHANCED VERSION WITH VISIBLE EFFECTS
     ============================================ */
  
  .sim-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
  
  @media (max-width: 800px) {
    .sim-container { 
      grid-template-columns: 1fr;
      gap: 0.5rem;
    }
    
    /* Su mobile: preview PRIMA, controlli DOPO */
    .sim-preview { order: -1; }
    
    .sim-controls {
      padding: 0.5rem 0.75rem !important;
    }
    
    .control-group {
      margin-bottom: 0.4rem !important;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.25rem;
    }
    
    .control-group .control-label {
      width: 100%;
      margin-bottom: 0 !important;
    }
    
    .control-group input[type="range"] {
      flex: 1;
      min-width: 0;
    }
    
    .control-group .control-hint {
      margin-top: 0 !important;
      margin-left: 0.5rem;
      font-size: 0.6rem !important;
      white-space: nowrap;
    }
    
    .control-label span:first-child {
      font-size: 0.65rem !important;
    }
    
    .control-value {
      font-size: 0.95rem !important;
    }
    
    /* EV meter compatto inline */
    .ev-meter {
      padding: 0.4rem 0.6rem !important;
      margin-top: 0.4rem !important;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: 0.4rem !important;
      text-align: left !important;
    }
    
    .ev-meter .label {
      display: none !important;
    }
    
    .ev-value {
      font-size: 1rem !important;
    }
    
    .exposure-status {
      font-size: 0.65rem !important;
      margin-top: 0 !important;
      padding: 0.2rem 0.35rem !important;
      white-space: nowrap;
    }
    
    /* Preview compatta 3:1 */
    .preview-frame {
      aspect-ratio: 3/1 !important;
    }
    
    /* Preset compatti su mobile */
    .sim-presets {
      margin-top: 1rem;
      padding: 0.5rem !important;
    }
    
    .sim-presets h3 {
      font-size: 0.7rem !important;
      margin-bottom: 0.4rem !important;
    }
    
    .preset-btn {
      padding: 0.3rem 0.4rem !important;
      font-size: 0.65rem !important;
    }
    
    .preset-grid {
      gap: 0.25rem !important;
    }
    
    .sim-rationale {
      padding: 0.4rem 0.6rem !important;
      font-size: 0.75rem !important;
      margin-top: 0.5rem !important;
    }
  }
  
  /* Touch-friendly sliders */
  input[type="range"] {
    width: 100%;
    height: 8px;
    -webkit-appearance: none;
    appearance: none;
    background: var(--bg-secondary);
    border-radius: 4px;
    outline: none;
    touch-action: none;
    cursor: pointer;
    margin: 4px 0;
  }
  
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 28px;
    height: 28px;
    background: var(--accent);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(212, 165, 116, 0.5);
    border: 3px solid var(--bg-primary);
  }
  
  input[type="range"]::-moz-range-thumb {
    width: 28px;
    height: 28px;
    background: var(--accent);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(212, 165, 116, 0.5);
    border: 3px solid var(--bg-primary);
  }
  
  input[type="range"]:active::-webkit-slider-thumb {
    transform: scale(1.15);
    box-shadow: 0 2px 12px rgba(212, 165, 116, 0.7);
  }
  
  @media (max-width: 800px) {
    input[type="range"] {
      height: 10px !important;
    }
    
    input[type="range"]::-webkit-slider-thumb {
      width: 32px !important;
      height: 32px !important;
    }
    
    input[type="range"]::-moz-range-thumb {
      width: 32px !important;
      height: 32px !important;
    }
  }
  
  /* Preset Buttons */
  .sim-presets {
    background: var(--bg-card);
    border-radius: 12px;
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  @media (max-width: 800px) {
    .sim-presets {
      padding: 0.6rem;
      margin-bottom: 0.75rem;
    }
    
    .sim-presets h3 {
      font-size: 0.65rem !important;
      margin-bottom: 0.4rem !important;
    }
    
    .preset-btn {
      padding: 0.3rem 0.4rem !important;
      font-size: 0.65rem !important;
    }
    
    .sim-rationale {
      padding: 0.4rem 0.6rem !important;
      font-size: 0.75rem !important;
      margin-bottom: 0.5rem !important;
    }
  }
  
  .sim-presets h3 {
    font-size: 0.85rem;
    color: var(--text-muted);
    margin-bottom: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .preset-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  
  @media (max-width: 800px) {
    .preset-grid {
      gap: 0.25rem;
    }
  }
  
  .preset-btn {
    padding: 0.5rem 0.75rem;
    background: var(--bg-secondary);
    border: 1px solid var(--border);
    border-radius: 6px;
    color: var(--text-secondary);
    font-size: 0.8rem;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 0.35rem;
  }
  
  .preset-btn:hover {
    background: var(--accent-dim);
    color: var(--accent);
    border-color: var(--accent);
  }
  
  .preset-btn.active {
    background: var(--accent);
    color: var(--bg-primary);
    border-color: var(--accent);
  }
  
  .preset-btn .tipo-badge {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }
  
  .preset-btn .tipo-badge.bw { background: linear-gradient(135deg, #fff 50%, #333 50%); }
  .preset-btn .tipo-badge.color { background: linear-gradient(135deg, #ff6b6b, #4ecdc4, #ffe66d); }
  
  /* Rationale Tooltip */
  .sim-rationale {
    background: var(--accent-dim);
    border-left: 3px solid var(--accent);
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    border-radius: 0 8px 8px 0;
    font-size: 0.9rem;
    color: var(--text-secondary);
  }
  
  .sim-rationale strong {
    color: var(--accent);
    display: block;
    margin-bottom: 0.25rem;
  }
  
  /* Controls Panel */
  .sim-controls {
    background: var(--bg-card);
    border-radius: 12px;
    padding: 1.5rem;
  }
  
  .control-group {
    margin-bottom: 1.5rem;
  }
  
  .control-group:last-child { margin-bottom: 0; }
  
  .control-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }
  
  .control-label span:first-child {
    font-size: 0.85rem;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .control-value {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem;
    color: var(--accent);
    font-weight: 600;
  }
  
  .control-hint {
    font-size: 0.75rem;
    color: var(--text-muted);
    margin-top: 0.35rem;
    min-height: 1em;
  }
  
  /* EV Meter */
  .ev-meter {
    background: var(--bg-secondary);
    border-radius: 8px;
    padding: 1rem;
    margin-top: 1.5rem;
    text-align: center;
  }
  
  .ev-meter .label {
    font-size: 0.75rem;
    color: var(--text-muted);
    text-transform: uppercase;
    margin-bottom: 0.5rem;
  }
  
  .ev-value {
    font-family: 'Playfair Display', serif;
    font-size: 2rem;
    font-weight: 700;
  }
  
  .ev-value.under { color: var(--danger); }
  .ev-value.ok { color: var(--success); }
  .ev-value.over { color: var(--warning); }
  
  .exposure-status {
    font-size: 0.9rem;
    margin-top: 0.5rem;
    padding: 0.5rem;
    border-radius: 6px;
  }
  
  .exposure-status.under { background: rgba(248, 113, 113, 0.15); color: var(--danger); }
  .exposure-status.ok { background: rgba(74, 222, 128, 0.15); color: var(--success); }
  .exposure-status.over { background: rgba(251, 191, 36, 0.15); color: var(--warning); }
  
  /* Preview Panel - NEW STRUCTURE */
  .sim-preview {
    background: var(--bg-card);
    border-radius: 12px;
    overflow: hidden;
  }
  
  .preview-frame {
    aspect-ratio: 3/2;
    position: relative;
    overflow: hidden;
    background: linear-gradient(180deg, #4a6fa5 0%, #7ba3d4 30%, #a5c4e8 60%, #d4e5f7 100%);
    transition: filter 0.3s ease;
  }
  
  /* SKY with sun and clouds */
  .scene-sky {
    position: absolute;
    inset: 0;
    bottom: 40%;
    transition: filter 0.3s ease;
  }
  
  .sun {
    position: absolute;
    top: 15%;
    right: 20%;
    width: 50px;
    height: 50px;
    background: radial-gradient(circle, #fff9c4 0%, #ffee58 50%, #ffca28 100%);
    border-radius: 50%;
    box-shadow: 0 0 40px 15px rgba(255, 236, 64, 0.4);
  }
  
  .cloud {
    position: absolute;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 50px;
  }
  
  .cloud::before, .cloud::after {
    content: '';
    position: absolute;
    background: inherit;
    border-radius: 50%;
  }
  
  .cloud-1 {
    top: 20%;
    left: 10%;
    width: 80px;
    height: 30px;
  }
  .cloud-1::before { width: 40px; height: 40px; top: -20px; left: 15px; }
  .cloud-1::after { width: 30px; height: 30px; top: -10px; left: 45px; }
  
  .cloud-2 {
    top: 35%;
    left: 50%;
    width: 60px;
    height: 25px;
  }
  .cloud-2::before { width: 35px; height: 35px; top: -18px; left: 10px; }
  .cloud-2::after { width: 25px; height: 25px; top: -8px; left: 35px; }
  
  /* Buildings / Midground */
  .scene-buildings {
    position: absolute;
    bottom: 25%;
    left: 0;
    right: 0;
    height: 35%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 3%;
    padding: 0 5%;
    transition: filter 0.3s ease;
  }
  
  .building {
    background: linear-gradient(180deg, #37474f 0%, #263238 100%);
    border-radius: 2px 2px 0 0;
    position: relative;
  }
  
  .building::before {
    content: '';
    position: absolute;
    inset: 10% 15%;
    background: 
      repeating-linear-gradient(
        0deg,
        transparent,
        transparent 8px,
        rgba(255,200,100,0.3) 8px,
        rgba(255,200,100,0.3) 12px
      ),
      repeating-linear-gradient(
        90deg,
        transparent,
        transparent 10px,
        rgba(255,200,100,0.3) 10px,
        rgba(255,200,100,0.3) 14px
      );
  }
  
  .b1 { width: 12%; height: 50%; }
  .b2 { width: 15%; height: 75%; }
  .b3 { width: 10%; height: 60%; }
  .b4 { width: 18%; height: 90%; }
  .b5 { width: 13%; height: 55%; }
  
  /* Ground / Foreground */
  .scene-ground {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 30%;
  }
  
  .ground-plane {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, #5d4037 0%, #3e2723 100%);
  }
  
  .ground-plane::before {
    content: '';
    position: absolute;
    inset: 0;
    background: repeating-linear-gradient(
      90deg,
      transparent 0%,
      transparent 48%,
      rgba(255,255,255,0.1) 49%,
      rgba(255,255,255,0.1) 51%,
      transparent 52%,
      transparent 100%
    );
  }
  
  /* Human figure - SUBJECT */
  .subject-figure {
    position: absolute;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
    transition: filter 0.3s ease, transform 0.3s ease;
  }
  
  .figure-head {
    width: 24px;
    height: 24px;
    background: linear-gradient(180deg, #ffccbc 0%, #d7a38b 100%);
    border-radius: 50%;
    margin: 0 auto 2px;
  }
  
  .figure-body {
    width: 36px;
    height: 60px;
    background: linear-gradient(180deg, #1565c0 0%, #0d47a1 100%);
    border-radius: 8px 8px 4px 4px;
    margin: 0 auto;
  }
  
  .figure-shadow {
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 12px;
    background: rgba(0,0,0,0.3);
    border-radius: 50%;
    filter: blur(4px);
  }
  
  /* EFFECT OVERLAYS */
  .motion-overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 10;
    animation: motionShift 0.15s linear infinite alternate;
  }
  
  @keyframes motionShift {
    from { transform: translateX(-2%); }
    to { transform: translateX(2%); }
  }
  
  .grain-overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 15;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
    background-size: 128px 128px;
    mix-blend-mode: overlay;
    animation: grainAnim 0.2s steps(4) infinite;
  }
  
  @keyframes grainAnim {
    0% { transform: translate(0, 0); }
    25% { transform: translate(-3%, 3%); }
    50% { transform: translate(3%, -3%); }
    75% { transform: translate(-3%, -3%); }
    100% { transform: translate(3%, 3%); }
  }
  
  .exposure-clip {
    position: absolute;
    inset: 0;
    pointer-events: none;
    transition: opacity 0.15s ease;
    z-index: 20;
  }
  
  .exposure-clip.over {
    mix-blend-mode: screen;
  }
  
  .exposure-clip.under {
    mix-blend-mode: multiply;
  }
  
  .ev-value.over.severe { color: #ff6b6b; font-weight: 700; }
  .ev-value.over.moderate { color: #ffa94d; }
  .ev-value.over.mild { color: #ffe066; }
  .ev-value.under.severe { color: #845ef7; font-weight: 700; }
  .ev-value.under.moderate { color: #5c7cfa; }
  .ev-value.under.mild { color: #74c0fc; }
  .ev-value.ok { color: var(--success); }
  
  /* Effect bars */
  .effect-bars {
    padding: 1rem;
    display: grid;
    gap: 0.75rem;
  }
  
  .effect-bar {
    display: grid;
    grid-template-columns: 100px 1fr auto;
    align-items: center;
    gap: 0.75rem;
  }
  
  .effect-bar .label {
    font-size: 0.8rem;
    color: var(--text-muted);
  }
  
  .effect-bar .bar {
    height: 6px;
    background: var(--bg-secondary);
    border-radius: 3px;
    overflow: hidden;
  }
  
  .effect-bar .bar-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.3s ease;
  }
  
  .effect-bar .bar-fill.dof { background: linear-gradient(90deg, #4ecdc4, #44a08d); }
  .effect-bar .bar-fill.motion { background: linear-gradient(90deg, #f093fb, #f5576c); }
  .effect-bar .bar-fill.noise { background: linear-gradient(90deg, #ffecd2, #fcb69f); }
  
  .effect-bar .value {
    font-size: 0.75rem;
    color: var(--text-secondary);
    min-width: 80px;
    text-align: right;
  }
  
  /* ============================================
     MAESTRI CARDS
     ============================================ */
  
  .filter-row {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
  }
  
  .filter-btn {
    padding: 0.5rem 1rem;
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: 20px;
    color: var(--text-secondary);
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .filter-btn:hover { border-color: var(--accent); color: var(--text-primary); }
  .filter-btn.active { background: var(--accent); color: var(--bg-primary); border-color: var(--accent); }
  
  .maestri-grid {
    display: grid;
    gap: 1rem;
  }
  
  .maestro-card {
    background: var(--bg-card);
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid var(--border);
  }
  
  .maestro-card:hover {
    background: var(--bg-card-hover);
    border-color: rgba(212, 165, 116, 0.3);
  }
  
  .maestro-header {
    padding: 1rem 1.25rem;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  
  .tipo-badge {
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .tipo-badge.bw { background: #333; color: #fff; }
  .tipo-badge.color { background: linear-gradient(135deg, #ff6b6b, #4ecdc4); color: #fff; }
  
  .maestro-info { flex: 1; }
  .maestro-info h3 { font-family: 'Playfair Display', serif; font-size: 1.1rem; margin-bottom: 0.15rem; }
  .maestro-info .titolo { color: var(--accent); font-size: 0.9rem; }
  .maestro-info .scuola { color: var(--text-muted); font-size: 0.8rem; margin-top: 0.25rem; }
  
  .expand-icon {
    color: var(--text-muted);
    font-size: 1.25rem;
    transition: transform 0.3s;
  }
  
  .maestro-card.expanded .expand-icon { transform: rotate(180deg); }
  
  .maestro-body {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease;
  }
  
  .maestro-card.expanded .maestro-body {
    max-height: 1500px;
  }
  
  .maestro-content {
    padding: 0 1.25rem 1.25rem;
    border-top: 1px solid var(--border);
  }
  
  .maestro-section {
    padding: 1rem 0;
    border-bottom: 1px solid var(--border);
  }
  
  .maestro-section:last-child { border-bottom: none; }
  
  .maestro-section h4 {
    font-size: 0.75rem;
    color: var(--accent);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .maestro-section p {
    color: var(--text-secondary);
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  .settings-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 0.75rem;
    margin-top: 0.5rem;
  }
  
  .setting-item {
    background: var(--bg-secondary);
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    text-align: center;
  }
  
  .setting-item .label { font-size: 0.7rem; color: var(--text-muted); text-transform: uppercase; }
  .setting-item .value { font-family: 'Playfair Display', serif; font-size: 1rem; color: var(--text-primary); margin-top: 0.15rem; }
  
  .esempio-box {
    background: var(--accent-dim);
    border-left: 3px solid var(--accent);
    padding: 1rem;
    border-radius: 0 8px 8px 0;
    font-style: italic;
    color: var(--text-secondary);
  }
  
  .missione-box {
    background: linear-gradient(135deg, rgba(251, 191, 36, 0.15), rgba(251, 146, 60, 0.1));
    border: 1px solid rgba(251, 191, 36, 0.3);
    padding: 1rem;
    border-radius: 8px;
    color: var(--text-primary);
    font-weight: 500;
    line-height: 1.5;
  }
  
  .iphone-box {
    background: rgba(74, 222, 128, 0.08);
    border: 1px solid rgba(74, 222, 128, 0.2);
    border-radius: 8px;
    padding: 0.75rem;
    margin-top: 0.5rem;
  }
  
  .iphone-row {
    display: grid;
    grid-template-columns: 90px 1fr;
    gap: 0.5rem;
    padding: 0.4rem 0;
    border-bottom: 1px solid rgba(74, 222, 128, 0.1);
  }
  
  .iphone-row:last-of-type {
    border-bottom: none;
  }
  
  .iphone-label {
    font-size: 0.75rem;
    color: var(--success);
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-weight: 600;
  }
  
  .iphone-value {
    font-size: 0.85rem;
    color: var(--text-secondary);
    line-height: 1.4;
  }
  
  .iphone-tip {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px dashed rgba(74, 222, 128, 0.3);
    font-size: 0.85rem;
    color: var(--text-primary);
    font-style: italic;
    line-height: 1.5;
  }
  
  /* ============================================
     SCENARI CARDS
     ============================================ */
  
  .search-box {
    margin-bottom: 1.5rem;
  }
  
  .search-box input {
    width: 100%;
    padding: 0.75rem 1rem;
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: 8px;
    color: var(--text-primary);
    font-size: 1rem;
  }
  
  .search-box input:focus {
    outline: none;
    border-color: var(--accent);
  }
  
  .search-box input::placeholder { color: var(--text-muted); }
  
  .scenari-grid {
    display: grid;
    gap: 1rem;
  }
  
  .scenario-card {
    background: var(--bg-card);
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid var(--border);
  }
  
  .scenario-card:hover {
    background: var(--bg-card-hover);
    border-color: rgba(212, 165, 116, 0.3);
  }
  
  .scenario-header {
    padding: 1rem 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .scenario-header h3 { font-size: 1.1rem; }
  
  .scenario-body {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }
  
  .scenario-card.expanded .scenario-body { max-height: 500px; }
  
  .scenario-content {
    padding: 0 1.25rem 1.25rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
  
  @media (max-width: 600px) {
    .scenario-content { grid-template-columns: 1fr; }
  }
  
  .scenario-col {
    background: var(--bg-secondary);
    padding: 1rem;
    border-radius: 8px;
  }
  
  .scenario-col h4 {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .scenario-col.reflex h4 { color: var(--accent); }
  .scenario-col.iphone h4 { color: var(--success); }
  
  .scenario-settings {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
  }
  
  .scenario-setting {
    background: var(--bg-card);
    padding: 0.35rem 0.6rem;
    border-radius: 4px;
    font-size: 0.85rem;
    color: var(--text-primary);
  }
  
  .scenario-note {
    font-size: 0.85rem;
    color: var(--text-secondary);
    line-height: 1.5;
  }
  
  .mode-badge {
    display: inline-block;
    background: var(--success);
    color: var(--bg-primary);
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .iphone-details {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  
  .scenario-col.iphone .iphone-row {
    display: grid;
    grid-template-columns: 110px 1fr;
    gap: 0.5rem;
    padding: 0.5rem 0;
    border-bottom: 1px solid rgba(74, 222, 128, 0.1);
  }
  
  .scenario-col.iphone .iphone-row:last-of-type {
    border-bottom: none;
  }
  
  .scenario-col.iphone .iphone-label {
    font-size: 0.7rem;
    color: var(--success);
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-weight: 600;
    white-space: nowrap;
  }
  
  .scenario-col.iphone .iphone-value {
    font-size: 0.8rem;
    color: var(--text-secondary);
    line-height: 1.4;
  }
  
  .scenario-col.iphone .iphone-tip {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px dashed rgba(74, 222, 128, 0.3);
    font-size: 0.8rem;
    color: var(--text-primary);
    font-style: italic;
    line-height: 1.5;
  }
  .scenario-maestri {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--border);
  }
  
  .maestri-label {
    font-size: 0.8rem;
    color: var(--text-muted);
  }
  
  .maestro-tag {
    padding: 0.25rem 0.6rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 500;
  }
  
  .maestro-tag.bw {
    background: rgba(255, 255, 255, 0.1);
    color: var(--text-secondary);
    border: 1px solid var(--border);
  }
  
  .maestro-tag.colore {
    background: rgba(251, 146, 60, 0.15);
    color: #fb923c;
    border: 1px solid rgba(251, 146, 60, 0.3);
  }
  
  /* ============================================
     STREET & B/N SECTIONS
     ============================================ */
  
  .principle-card {
    background: var(--bg-card);
    border-radius: 12px;
    padding: 1.25rem;
    margin-bottom: 1rem;
  }
  
  .principle-card h3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.1rem;
    color: var(--accent);
    margin-bottom: 0.5rem;
  }
  
  .principle-card p {
    color: var(--text-secondary);
    font-size: 0.95rem;
  }
  
  .dual-setup {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-top: 1.5rem;
    padding: 1rem;
    background: var(--bg-card);
    border-radius: 12px;
  }
  
  @media (max-width: 600px) {
    .dual-setup { grid-template-columns: 1fr; }
  }
  
  .setup-col h4 {
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.5rem;
  }
  
  .setup-col.reflex h4 { color: var(--accent); }
  .setup-col.iphone h4 { color: var(--success); }
  
  .setup-col p {
    color: var(--text-secondary);
    font-size: 0.9rem;
  }
  
  .bw-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  @media (max-width: 600px) {
    .bw-grid { grid-template-columns: 1fr; }
  }
  
  .bw-col h3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.1rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .bw-col.yes h3 { color: var(--success); }
  .bw-col.no h3 { color: var(--danger); }
  
  .bw-col ul {
    list-style: none;
  }
  
  .bw-col li {
    padding: 0.5rem 0;
    color: var(--text-secondary);
    font-size: 0.95rem;
    border-bottom: 1px solid var(--border);
  }
  
  .bw-col li:last-child { border-bottom: none; }
  
  .exercise-box {
    background: var(--bg-card);
    border-radius: 12px;
    padding: 1.25rem;
  }
  
  .exercise-box h3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.1rem;
    color: var(--accent);
    margin-bottom: 0.75rem;
  }
  
  .exercise-box p {
    color: var(--text-secondary);
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }
  
  /* ============================================
     TOOLS SECTION
     ============================================ */
  
  .calc-container {
    background: var(--bg-card);
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .calc-container h3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }
  
  .mp-display {
    text-align: center;
    margin-bottom: 1rem;
  }
  
  .mp-value {
    font-family: 'Playfair Display', serif;
    font-size: 3rem;
    color: var(--accent);
  }
  
  .mp-label {
    font-size: 0.9rem;
    color: var(--text-muted);
  }
  
  .print-matrix {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;
    margin-top: 1rem;
  }
  
  @media (max-width: 600px) {
    .print-matrix { grid-template-columns: repeat(2, 1fr); }
  }
  
  .print-cell {
    background: var(--bg-secondary);
    padding: 0.75rem;
    border-radius: 8px;
    text-align: center;
  }
  
  .print-cell .size {
    font-size: 0.85rem;
    color: var(--text-primary);
    margin-bottom: 0.25rem;
  }
  
  .print-cell .quality {
    font-size: 1.1rem;
  }
  
  .quality-legend {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    margin-top: 1rem;
    flex-wrap: wrap;
  }
  
  .quality-legend span {
    font-size: 0.8rem;
    color: var(--text-muted);
  }
  
  .comp-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 0.75rem;
  }
  
  .comp-card {
    background: var(--bg-card);
    padding: 1rem;
    border-radius: 8px;
    border: 1px solid var(--border);
  }
  
  .comp-card h4 {
    font-size: 0.95rem;
    color: var(--text-primary);
    margin-bottom: 0.35rem;
  }
  
  .comp-card p {
    font-size: 0.85rem;
    color: var(--text-muted);
  }
  
  /* GLOSSARIO */
  .glossario {
    margin-bottom: 2rem;
  }
  
  .glossario-toggle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 1rem;
    color: var(--text-primary);
  }
  
  .glossario-toggle:hover {
    background: var(--bg-card-hover);
    border-color: var(--accent);
  }
  
  .glossario-toggle span:first-child {
    font-weight: 600;
    font-size: 1.1rem;
  }
  
  .glossario-count {
    color: var(--text-muted);
    font-size: 0.85rem;
    font-weight: 400;
  }
  
  .glossario-arrow {
    color: var(--accent);
    font-size: 0.8rem;
    transition: transform 0.2s ease;
  }
  
  .glossario-arrow.open {
    transform: rotate(180deg);
  }
  
  .glossario-content {
    margin-top: 1rem;
    padding: 1rem;
    background: var(--bg-secondary);
    border-radius: 12px;
    border: 1px solid var(--border);
  }
  
  .glossario-search {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: var(--bg-card);
    color: var(--text-primary);
    margin-bottom: 1rem;
  }
  
  .glossario-search::placeholder {
    color: var(--text-muted);
  }
  
  .glossario-search:focus {
    outline: none;
    border-color: var(--accent);
  }
  
  .glossario-filtri {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }
  
  .filtro-btn {
    padding: 0.4rem 0.75rem;
    font-size: 0.8rem;
    border: 1px solid var(--border);
    border-radius: 20px;
    background: var(--bg-card);
    color: var(--text-muted);
    cursor: pointer;
    transition: all 0.15s ease;
  }
  
  .filtro-btn:hover {
    border-color: var(--text-secondary);
    color: var(--text-secondary);
  }
  
  .filtro-btn.active {
    background: var(--accent);
    border-color: var(--accent);
    color: white;
  }
  
  .glossario-lista {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    max-height: 60vh;
    overflow-y: auto;
  }
  
  .glossario-item {
    padding: 1rem;
    background: var(--bg-card);
    border-radius: 8px;
    border: 1px solid var(--border);
  }
  
  .glossario-item dt {
    font-weight: 600;
    color: var(--accent);
    margin-bottom: 0.4rem;
    font-size: 0.95rem;
  }
  
  .glossario-item dd {
    color: var(--text-secondary);
    font-size: 0.9rem;
    line-height: 1.5;
    margin: 0;
  }
  
  .glossario-empty {
    text-align: center;
    color: var(--text-muted);
    padding: 2rem;
  }
  
  /* INIZIA SECTION */
  .inizia-section {
    max-width: 700px;
  }
  
  .istruzioni-app {
    background: var(--bg-card);
    border-radius: 12px;
    padding: 1.25rem;
    margin-bottom: 1.5rem;
  }
  
  .istruzioni-app h3 {
    margin: 0 0 1rem 0;
    font-size: 1rem;
    color: var(--text-primary);
  }
  
  .istruzioni-app ul {
    margin: 0;
    padding-left: 0;
    list-style: none;
  }
  
  .istruzioni-app li {
    margin-bottom: 0.75rem;
    color: var(--text-secondary);
    font-size: 0.9rem;
    line-height: 1.5;
  }
  
  .istruzioni-app li:last-child {
    margin-bottom: 0;
  }
  
  .istruzioni-app strong {
    color: var(--accent);
  }
  
  .sezione-divider {
    border: none;
    border-top: 1px solid var(--border);
    margin: 2rem 0;
  }
  
  .inizia-intro {
    margin-bottom: 1.5rem;
  }
  
  .inizia-intro h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1rem;
    color: var(--text-primary);
  }
  
  .inizia-intro p {
    margin: 0;
    color: var(--text-secondary);
    font-size: 0.9rem;
  }
  
  .percorso-lista {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
  
  .percorso-step {
    background: var(--bg-card);
    border-radius: 12px;
    padding: 1.25rem;
    border: 1px solid var(--border);
  }
  
  .step-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.75rem;
  }
  
  .step-badge {
    background: var(--accent);
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
  }
  
  .step-header h3 {
    font-size: 1.1rem;
    color: var(--text-primary);
    margin: 0;
  }
  
  .step-desc {
    color: var(--text-secondary);
    font-size: 0.95rem;
    margin-bottom: 1rem;
    line-height: 1.5;
  }
  
  .step-azioni {
    margin: 0;
    padding-left: 1.25rem;
    color: var(--text-secondary);
  }
  
  .step-azioni li {
    margin-bottom: 0.4rem;
    font-size: 0.9rem;
  }
  
  .step-go {
    margin-top: 1rem;
    padding: 0.6rem 1rem;
    background: transparent;
    border: 1px solid var(--accent);
    color: var(--accent);
    border-radius: 8px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.15s ease;
  }
  
  .step-go:hover {
    background: var(--accent);
    color: white;
  }
  
  .inizia-footer {
    margin-top: 2rem;
    padding: 1rem;
    text-align: center;
    color: var(--text-muted);
    font-size: 0.9rem;
  }
  
  .inizia-footer em {
    color: var(--text-secondary);
  }

  /* ============================================
     SCROLL TO TOP BUTTON
     ============================================ */
  .scroll-to-top {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: var(--accent);
    color: var(--bg-primary);
    border: none;
    font-size: 1.4rem;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(212, 165, 116, 0.4);
    z-index: 200;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.3s, transform 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .scroll-to-top.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .scroll-to-top:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(212, 165, 116, 0.6);
  }

  /* ============================================
     SCUOLA FILTER
     ============================================ */
  .filter-group {
    margin-bottom: 1.5rem;
  }

  .filter-group-label {
    font-size: 0.75rem;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.5rem;
  }

  /* ============================================
     CLICKABLE MAESTRO TAGS
     ============================================ */
  .maestro-tag.clickable {
    cursor: pointer;
    transition: all 0.2s;
  }

  .maestro-tag.clickable:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(212, 165, 116, 0.3);
  }

  .maestro-tag.bw.clickable:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: var(--text-secondary);
  }

  .maestro-tag.colore.clickable:hover {
    background: rgba(251, 146, 60, 0.25);
    border-color: #fb923c;
  }

  /* ============================================
     HIGHLIGHTED MAESTRO CARD
     ============================================ */
  .maestro-card.highlighted {
    border-color: var(--accent);
    box-shadow: 0 0 20px rgba(212, 165, 116, 0.3);
    animation: highlightPulse 1.5s ease-out;
  }

  @keyframes highlightPulse {
    0% { box-shadow: 0 0 0 0 rgba(212, 165, 116, 0.6); }
    70% { box-shadow: 0 0 20px 8px rgba(212, 165, 116, 0.15); }
    100% { box-shadow: 0 0 20px rgba(212, 165, 116, 0.3); }
  }

  /* ============================================
     SIMULATOR RESET BUTTON
     ============================================ */
  .sim-reset-btn {
    padding: 0.5rem 1rem;
    background: transparent;
    border: 1px solid var(--border);
    color: var(--text-muted);
    border-radius: 6px;
    font-size: 0.8rem;
    cursor: pointer;
    transition: all 0.2s;
    margin-top: 0.75rem;
    width: 100%;
  }

  .sim-reset-btn:hover {
    border-color: var(--danger);
    color: var(--danger);
  }

  /* ============================================
     IMPROVED MOBILE RESPONSIVENESS
     ============================================ */
  @media (max-width: 480px) {
    .header {
      padding: 2rem 1rem 1.5rem;
    }

    .header h1 {
      font-size: 1.75rem;
    }

    .header .subtitle {
      font-size: 0.95rem;
    }

    .nav {
      padding: 0.5rem;
      gap: 0.15rem;
    }

    .nav-btn {
      padding: 0.5rem 0.4rem;
      font-size: 0.7rem;
      min-width: 0;
    }

    .nav-btn span {
      font-size: 1rem;
    }

    .section {
      padding: 1.25rem 1rem;
    }

    .section-title {
      font-size: 1.4rem;
    }

    .filter-row {
      gap: 0.35rem;
    }

    .filter-btn {
      padding: 0.4rem 0.7rem;
      font-size: 0.78rem;
    }

    .maestro-header {
      padding: 0.85rem 1rem;
      gap: 0.75rem;
    }

    .maestro-info h3 {
      font-size: 1rem;
    }

    .scenario-header {
      padding: 0.85rem 1rem;
    }

    .scenario-maestri {
      padding: 0 1rem 1rem;
    }

    .scroll-to-top {
      bottom: 1.25rem;
      right: 1.25rem;
      width: 44px;
      height: 44px;
    }
  }
`;
// ============================================
// COMPONENTS
// ============================================
// Enhanced Exposure Simulator
function SimulatoreEsposizione() {
  // Default: f/4, 1/60, ISO 100 → esposizione corretta per scena EV 10
  const [aperture, setAperture] = useState(4);
  const [shutter, setShutter] = useState(60);
  const [iso, setIso] = useState(100);
  const [activeMaestro, setActiveMaestro] = useState(null);
  
  const apertureStops = [1.4, 2, 2.8, 4, 5.6, 8, 11, 16, 22];
  const shutterSpeeds = [1, 2, 4, 8, 15, 30, 60, 125, 250, 500, 1000];
  const isoValues = [100, 200, 400, 800, 1600, 3200, 6400];
  
  const apertureIndex = apertureStops.indexOf(aperture);
  const shutterIndex = shutterSpeeds.indexOf(shutter);
  const isoIndex = isoValues.indexOf(iso);
  
  // ESPOSIZIONE BASATA SU EV (Exposure Value)
  // La scena è un interno ben illuminato (EV 10)
  // Con f/4, 1/60, ISO 100 → cameraEV ≈ 10 → esposizione corretta
  // Margine: puoi aprire a f/1.4 (+3 stop) o chiudere a f/22 (-5 stop)
  
  const sceneEV = 10;
  
  // EV della camera = log2(N² × t) dove t è il denominatore (60 per 1/60s)
  const cameraEV = Math.log2((aperture * aperture) * shutter);
  
  // ISO: ogni raddoppio = +1 stop di sensibilità
  const isoStops = Math.log2(iso / 100);
  
  // EV effettivo (con ISO) - ISO alto riduce l'EV necessario
  const effectiveCameraEV = cameraEV - isoStops;
  
  // Differenza dall'esposizione corretta
  // Positivo = sottoesposto (camera cattura meno luce della scena)
  // Negativo = sovraesposto (camera cattura più luce della scena)
  const exposureDiff = effectiveCameraEV - sceneEV;
  
  // Clamp
  const clampedDiff = Math.max(-5, Math.min(5, exposureDiff));
  
  // Status testuale (nota: exposureDiff negativo = sovraesposto)
  const getExposureStatus = () => {
    const stops = Math.abs(Math.round(exposureDiff * 10) / 10);
    if (exposureDiff < -3) return { status: 'over', text: `+${stops.toFixed(1)} stop — BRUCIATO`, severity: 'severe' };
    if (exposureDiff < -2) return { status: 'over', text: `+${stops.toFixed(1)} stop — bianchi persi`, severity: 'severe' };
    if (exposureDiff < -1) return { status: 'over', text: `+${stops.toFixed(1)} stop — sovraesposto`, severity: 'moderate' };
    if (exposureDiff < -0.5) return { status: 'over', text: `+${stops.toFixed(1)} stop`, severity: 'mild' };
    if (exposureDiff > 3) return { status: 'under', text: `-${stops.toFixed(1)} stop — NERO`, severity: 'severe' };
    if (exposureDiff > 2) return { status: 'under', text: `-${stops.toFixed(1)} stop — ombre perse`, severity: 'severe' };
    if (exposureDiff > 1) return { status: 'under', text: `-${stops.toFixed(1)} stop — sottoesposto`, severity: 'moderate' };
    if (exposureDiff > 0.5) return { status: 'under', text: `-${stops.toFixed(1)} stop`, severity: 'mild' };
    return { status: 'ok', text: 'Esposizione corretta', severity: 'none' };
  };
  
  const exposure = getExposureStatus();
  
  // Effetti visivi DOF, motion, noise
  const dofPercent = Math.round((apertureIndex / (apertureStops.length - 1)) * 100);
  const motionRisk = Math.round((1 - shutterIndex / (shutterSpeeds.length - 1)) * 100);
  const noiseLevel = Math.round((isoIndex / (isoValues.length - 1)) * 100);
  
  // Blur
  const bgBlur = aperture <= 2 ? 12 : aperture <= 2.8 ? 8 : aperture <= 4 ? 5 : aperture <= 5.6 ? 2 : 0;
  const fgBlur = aperture <= 1.4 ? 6 : aperture <= 2 ? 4 : aperture <= 2.8 ? 2 : 0;
  
  // Motion blur
  const motionBlurAmount = shutter <= 4 ? 20 : shutter <= 8 ? 15 : shutter <= 15 ? 10 : shutter <= 30 ? 6 : shutter <= 60 ? 3 : 0;
  
  // Grain
  const grainAmount = iso >= 6400 ? 0.8 : iso >= 3200 ? 0.6 : iso >= 1600 ? 0.4 : iso >= 800 ? 0.25 : iso >= 400 ? 0.1 : 0;
  
  // === EFFETTI ESPOSIZIONE ===
  // Nota: clampedDiff negativo = sovraesposto (più luce del necessario)
  
  // Brightness
  const rawBrightness = Math.pow(1.5, -clampedDiff); // Invertiamo perché diff negativo = più luminoso
  const brightnessFactor = Math.max(0.2, Math.min(3.0, rawBrightness));
  
  // Sovraesposizione: bianco che mangia l'immagine
  let overBlowout = 0;
  if (clampedDiff < -1) {
    overBlowout = Math.min(0.92, Math.abs(clampedDiff + 1) * 0.25);
  }
  
  // Sottoesposizione: nero che inghiotte
  let underCrush = 0;
  if (clampedDiff > 1) {
    underCrush = Math.min(0.92, (clampedDiff - 1) * 0.25);
  }
  
  // Apply preset
  const applyPreset = (maestro) => {
    if (maestro.simSettings) {
      const { aperture: a, shutter: s, iso: i } = maestro.simSettings;
      if (apertureStops.includes(a)) setAperture(a);
      if (shutterSpeeds.includes(s)) setShutter(s);
      if (isoValues.includes(i)) setIso(i);
      setActiveMaestro(maestro);
    }
  };
  
  return (
    <div>
      <div className="sim-container">
        <div className="sim-controls">
          <div className="control-group">
            <div className="control-label">
              <span>Diaframma</span>
              <span className="control-value">f/{aperture}</span>
            </div>
            <input
              type="range"
              min="0"
              max={apertureStops.length - 1}
              value={apertureIndex}
              onChange={e => { setAperture(apertureStops[e.target.value]); setActiveMaestro(null); }}
            />
            <div className="control-hint">
              {aperture <= 2.8 && '← più luce, sfondo sfocato'}
              {aperture >= 11 && 'meno luce, tutto nitido →'}
            </div>
          </div>
          
          <div className="control-group">
            <div className="control-label">
              <span>Tempo</span>
              <span className="control-value">1/{shutter}s</span>
            </div>
            <input
              type="range"
              min="0"
              max={shutterSpeeds.length - 1}
              value={shutterIndex}
              onChange={e => { setShutter(shutterSpeeds[e.target.value]); setActiveMaestro(null); }}
            />
            <div className="control-hint">
              {shutter <= 30 && '← più luce, rischio mosso'}
              {shutter >= 500 && 'meno luce, congela →'}
            </div>
          </div>
          
          <div className="control-group">
            <div className="control-label">
              <span>ISO</span>
              <span className="control-value">{iso}</span>
            </div>
            <input
              type="range"
              min="0"
              max={isoValues.length - 1}
              value={isoIndex}
              onChange={e => { setIso(isoValues[e.target.value]); setActiveMaestro(null); }}
            />
            <div className="control-hint">
              {iso >= 1600 && '← più sensibile, grana'}
              {iso <= 200 && 'meno sensibile, pulito →'}
            </div>
          </div>
          
          <div className="ev-meter">
            <div className="label">Esposizione</div>
            <div className={`ev-value ${exposure.status} ${exposure.severity}`}>
              {exposureDiff <= 0 ? '+' : ''}{(-exposureDiff).toFixed(1)} stop
            </div>
            <div className={`exposure-status ${exposure.status}`}>{exposure.text}</div>
          </div>

          <button
            className="sim-reset-btn"
            onClick={() => { setAperture(4); setShutter(60); setIso(100); setActiveMaestro(null); }}
          >
            ↺ Reset (f/4 · 1/60s · ISO 100)
          </button>
        </div>

        {/* PREVIEW CON EFFETTI DRAMMATICI */}
        <div className="sim-preview">
          <div 
            className="preview-frame"
            style={{
              filter: `brightness(${brightnessFactor})`,
            }}
          >
            {/* Cielo */}
            <div className="scene-sky" style={{ filter: `blur(${bgBlur}px)` }}>
              <div className="sun"></div>
              <div className="cloud cloud-1"></div>
              <div className="cloud cloud-2"></div>
            </div>
            
            {/* Edifici */}
            <div className="scene-buildings" style={{ filter: `blur(${fgBlur}px)` }}>
              <div className="building b1"></div>
              <div className="building b2"></div>
              <div className="building b3"></div>
              <div className="building b4"></div>
              <div className="building b5"></div>
            </div>
            
            {/* Soggetto */}
            <div className="scene-ground">
              <div className="ground-plane"></div>
              <div 
                className="subject-figure"
                style={{ 
                  filter: motionBlurAmount > 0 ? `blur(${motionBlurAmount * 0.3}px)` : 'none',
                  transform: motionBlurAmount > 5 ? `translateX(${motionBlurAmount * 0.5}px)` : 'none'
                }}
              >
                <div className="figure-head"></div>
                <div className="figure-body"></div>
                <div className="figure-shadow"></div>
              </div>
            </div>
            
            {/* GRANA */}
            {grainAmount > 0 && (
              <div className="grain-overlay" style={{ opacity: grainAmount }}></div>
            )}
            
            {/* SOVRAESPOSIZIONE - bianco che brucia */}
            {overBlowout > 0 && (
              <div 
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: `radial-gradient(ellipse at 70% 25%, 
                    rgba(255,255,255,${Math.min(1, overBlowout * 1.5)}) 0%,
                    rgba(255,255,255,${overBlowout * 0.9}) 30%,
                    rgba(255,255,255,${overBlowout * 0.6}) 60%,
                    rgba(255,255,255,${overBlowout * 0.3}) 100%)`,
                  pointerEvents: 'none',
                  zIndex: 30
                }}
              />
            )}
            
            {/* SOTTOESPOSIZIONE - nero che inghiotte */}
            {underCrush > 0 && (
              <div 
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: `linear-gradient(to top,
                    rgba(0,0,0,${Math.min(1, underCrush * 1.3)}) 0%,
                    rgba(0,0,0,${underCrush * 0.8}) 40%,
                    rgba(0,0,0,${underCrush * 0.5}) 70%,
                    rgba(0,0,0,${underCrush * 0.2}) 100%)`,
                  pointerEvents: 'none',
                  zIndex: 30
                }}
              />
            )}
          </div>
          
          {/* Indicatori effetti */}
          <div className="effect-bars">
            <div className="effect-bar">
              <span className="label">Profondità</span>
              <div className="bar">
                <div className="bar-fill dof" style={{ width: `${dofPercent}%` }}></div>
              </div>
              <span className="value">{dofPercent < 30 ? '🔵 Sfocato' : dofPercent > 70 ? '🟢 Nitido' : '🟡 Media'}</span>
            </div>
            <div className="effect-bar">
              <span className="label">Mosso</span>
              <div className="bar">
                <div className="bar-fill motion" style={{ width: `${motionRisk}%` }}></div>
              </div>
              <span className="value">{motionRisk < 30 ? '🟢 Fermo' : motionRisk > 70 ? '🔴 Mosso!' : '🟡 Attenzione'}</span>
            </div>
            <div className="effect-bar">
              <span className="label">Rumore</span>
              <div className="bar">
                <div className="bar-fill noise" style={{ width: `${noiseLevel}%` }}></div>
              </div>
              <span className="value">{noiseLevel < 30 ? '🟢 Pulito' : noiseLevel > 70 ? '🔴 Grana!' : '🟡 Visibile'}</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Preset dei Maestri - in fondo per non rubare spazio */}
      <div className="sim-presets">
        <h3>🎨 Preset dei Maestri — clicca per applicare</h3>
        <div className="preset-grid">
          {MAESTRI.map(m => (
            <button
              key={m.id}
              className={`preset-btn ${activeMaestro?.id === m.id ? 'active' : ''}`}
              onClick={() => applyPreset(m)}
            >
              <span className={`tipo-badge ${m.tipo}`}></span>
              {m.nome.split(' ').pop()}
            </button>
          ))}
        </div>
      </div>
      
      {activeMaestro && (
        <div className="sim-rationale">
          <strong>{activeMaestro.nome}:</strong> {activeMaestro.simRationale}
        </div>
      )}
    </div>
  );
}
// Maestro Card
function MaestroCard({ maestro, forceExpand, isHighlighted, onHighlightClear }) {
  const [expanded, setExpanded] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    if (forceExpand) {
      setExpanded(true);
      setTimeout(() => {
        cardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
      if (onHighlightClear) {
        setTimeout(() => onHighlightClear(), 2000);
      }
    }
  }, [forceExpand]);

  return (
    <div
      ref={cardRef}
      className={`maestro-card ${expanded ? 'expanded' : ''} ${isHighlighted ? 'highlighted' : ''}`}
      onClick={() => setExpanded(!expanded)}
    >
      <div className="maestro-header">
        <span className={`tipo-badge ${maestro.tipo}`}>{maestro.tipo === 'bw' ? 'B/N' : 'Colore'}</span>
        <div className="maestro-info">
          <h3>{maestro.nome}</h3>
          <div className="titolo">{maestro.titolo}</div>
          <div className="scuola">{maestro.scuola}</div>
        </div>
        <span className="expand-icon">▼</span>
      </div>

      <div className="maestro-body">
        <div className="maestro-content">
          <div className="maestro-section">
            <h4>👁️ L'Occhio</h4>
            <p>{maestro.occhio}</p>
          </div>

          <div className="maestro-section">
            <h4>🚶 Il Corpo</h4>
            <p>{maestro.corpo}</p>
          </div>

          <div className="maestro-section">
            <h4>📷 La Macchina</h4>
            <p>{maestro.macchina}</p>
            <div className="settings-grid">
              <div className="setting-item">
                <div className="label">Diaframma</div>
                <div className="value">{maestro.settings.aperture}</div>
              </div>
              <div className="setting-item">
                <div className="label">Tempo</div>
                <div className="value">{maestro.settings.shutter}</div>
              </div>
              <div className="setting-item">
                <div className="label">ISO</div>
                <div className="value">{maestro.settings.iso}</div>
              </div>
              <div className="setting-item">
                <div className="label">Focale</div>
                <div className="value">{maestro.settings.focal}</div>
              </div>
            </div>
          </div>

          {maestro.iphone && (
            <div className="maestro-section">
              <h4>📱 iPhone</h4>
              <div className="iphone-box">
                <div className="iphone-row">
                  <span className="iphone-label">Lente</span>
                  <span className="iphone-value">{maestro.iphone.lente}</span>
                </div>
                <div className="iphone-row">
                  <span className="iphone-label">Modo</span>
                  <span className="iphone-value">{maestro.iphone.modo}</span>
                </div>
                <div className="iphone-row">
                  <span className="iphone-label">Esposizione</span>
                  <span className="iphone-value">{maestro.iphone.esposizione}</span>
                </div>
                <div className="iphone-row">
                  <span className="iphone-label">Focus</span>
                  <span className="iphone-value">{maestro.iphone.focus}</span>
                </div>
                <div className="iphone-row">
                  <span className="iphone-label">Editing</span>
                  <span className="iphone-value">{maestro.iphone.editing}</span>
                </div>
                <div className="iphone-tip">
                  💡 {maestro.iphone.tip}
                </div>
              </div>
            </div>
          )}

          <div className="maestro-section">
            <h4>💭 Esempio Mentale</h4>
            <div className="esempio-box">{maestro.esempio}</div>
          </div>

          {maestro.missione && (
            <div className="maestro-section missione">
              <div className="missione-box">{maestro.missione}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
// Maestri Section
function MaestriSection({ highlightedMaestro, onHighlightClear }) {
  const [filterTipo, setFilterTipo] = useState('all');
  const [filterScuola, setFilterScuola] = useState('all');

  const scuole = useMemo(() => [...new Set(MAESTRI.map(m => m.scuola))], []);

  const scuolaAbbr = {
    'Geometria e Rigore': 'Geometria',
    'Sentimento e Umano': 'Sentimento',
    'Astrazione e Caos': 'Astrazione',
    'Tecnica Pura': 'Tecnica',
    'Prospettiva Inusuale': 'Prospettiva'
  };

  // Reset scuola filter when highlighted maestro comes in
  useEffect(() => {
    if (highlightedMaestro) {
      setFilterTipo('all');
      setFilterScuola('all');
    }
  }, [highlightedMaestro]);

  const filtered = MAESTRI.filter(m => {
    const matchTipo = filterTipo === 'all' || m.tipo === filterTipo;
    const matchScuola = filterScuola === 'all' || m.scuola === filterScuola;
    return matchTipo && matchScuola;
  });

  return (
    <div>
      <div className="filter-group">
        <div className="filter-group-label">Tipo</div>
        <div className="filter-row">
          <button className={`filter-btn ${filterTipo === 'all' ? 'active' : ''}`} onClick={() => setFilterTipo('all')}>
            Tutti ({MAESTRI.length})
          </button>
          <button className={`filter-btn ${filterTipo === 'bw' ? 'active' : ''}`} onClick={() => setFilterTipo('bw')}>
            ◐ B/N ({MAESTRI.filter(m => m.tipo === 'bw').length})
          </button>
          <button className={`filter-btn ${filterTipo === 'color' ? 'active' : ''}`} onClick={() => setFilterTipo('color')}>
            🌈 Colore ({MAESTRI.filter(m => m.tipo === 'color').length})
          </button>
        </div>
      </div>

      <div className="filter-group">
        <div className="filter-group-label">Scuola</div>
        <div className="filter-row">
          <button className={`filter-btn ${filterScuola === 'all' ? 'active' : ''}`} onClick={() => setFilterScuola('all')}>
            Tutte
          </button>
          {scuole.map(s => (
            <button
              key={s}
              className={`filter-btn ${filterScuola === s ? 'active' : ''}`}
              onClick={() => setFilterScuola(s)}
            >
              {scuolaAbbr[s] || s} ({MAESTRI.filter(m => m.scuola === s).length})
            </button>
          ))}
        </div>
      </div>

      <div className="maestri-grid">
        {filtered.map(m => (
          <MaestroCard
            key={m.id}
            maestro={m}
            forceExpand={highlightedMaestro === m.id}
            isHighlighted={highlightedMaestro === m.id}
            onHighlightClear={onHighlightClear}
          />
        ))}
      </div>
    </div>
  );
}
// Scenario Card
function ScenarioCard({ scenario, onMaestroClick }) {
  const [expanded, setExpanded] = useState(false);

  // Trova i maestri collegati
  const maestriCollegati = scenario.maestriRef
    ? scenario.maestriRef.map(id => MAESTRI.find(m => m.id === id)).filter(Boolean)
    : [];

  return (
    <div className={`scenario-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(!expanded)}>
      <div className="scenario-header">
        <h3>{scenario.nome}</h3>
        <span className="expand-icon" style={{ transform: expanded ? 'rotate(180deg)' : 'none' }}>▼</span>
      </div>

      <div className="scenario-body">
        <div className="scenario-content">
          <div className="scenario-col reflex">
            <h4>📷 Reflex / Mirrorless</h4>
            <div className="scenario-settings">
              <span className="scenario-setting">{scenario.reflex.shutter}</span>
              <span className="scenario-setting">{scenario.reflex.aperture}</span>
              <span className="scenario-setting">ISO {scenario.reflex.iso}</span>
            </div>
            <p className="scenario-note">{scenario.reflex.note}</p>
          </div>

          <div className="scenario-col iphone">
            <h4>📱 iPhone 16 Pro</h4>
            <div className="iphone-details">
              <div className="iphone-row">
                <span className="iphone-label">🔭 Lente</span>
                <span className="iphone-value">{scenario.iphone.lente}</span>
              </div>
              <div className="iphone-row">
                <span className="iphone-label">📁 Formato</span>
                <span className="iphone-value">{scenario.iphone.formato}</span>
              </div>
              <div className="iphone-row">
                <span className="iphone-label">⚙️ Modo</span>
                <span className="iphone-value">{scenario.iphone.modo}</span>
              </div>
              <div className="iphone-row">
                <span className="iphone-label">🎛️ Camera Control</span>
                <span className="iphone-value">{scenario.iphone.camControl}</span>
              </div>
              <div className="iphone-row">
                <span className="iphone-label">☀️ Esposizione</span>
                <span className="iphone-value">{scenario.iphone.esposizione}</span>
              </div>
              <div className="iphone-row">
                <span className="iphone-label">🎨 Style</span>
                <span className="iphone-value">{scenario.iphone.style}</span>
              </div>
              <div className="iphone-row">
                <span className="iphone-label">✏️ Editing</span>
                <span className="iphone-value">{scenario.iphone.editing}</span>
              </div>
              <div className="iphone-tip">
                💡 {scenario.iphone.tip}
              </div>
            </div>
          </div>
        </div>

        {maestriCollegati.length > 0 && (
          <div className="scenario-maestri" style={{ padding: '0 1.25rem 1.25rem' }}>
            <span className="maestri-label">🎨 Studia:</span>
            {maestriCollegati.map(m => (
              <span
                key={m.id}
                className={`maestro-tag ${m.tipo === 'bw' ? 'bw' : 'colore'} clickable`}
                onClick={(e) => {
                  e.stopPropagation();
                  if (onMaestroClick) onMaestroClick(m.id);
                }}
                title={`Vai a ${m.nome}`}
              >
                {m.nome.split(' ').pop()}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
// Scenari Section
function ScenariSection({ onMaestroClick }) {
  const [search, setSearch] = useState('');

  const filtered = SCENARI.filter(s => {
    const q = search.toLowerCase();
    return (
      s.nome.toLowerCase().includes(q) ||
      s.reflex.note.toLowerCase().includes(q) ||
      s.iphone.tip.toLowerCase().includes(q) ||
      s.iphone.modo.toLowerCase().includes(q) ||
      s.iphone.lente.toLowerCase().includes(q)
    );
  });

  return (
    <div>
      <div className="search-box">
        <input
          type="text"
          placeholder="Cerca scenario, tecnica, tip..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="scenari-grid">
        {filtered.map(s => (
          <ScenarioCard key={s.id} scenario={s} onMaestroClick={onMaestroClick} />
        ))}
      </div>
    </div>
  );
}
// Street Section
function StreetSection() {
  const principles = [
    { nome: 'Anticipazione', desc: 'Prevedi dove succederà. Trova lo sfondo, aspetta che arrivi il soggetto.' },
    { nome: 'Invisibilità', desc: 'Vestiti neutro. Muoviti lento. Non fissare prima di scattare. Sii parte della scena.' },
    { nome: 'Luce Disponibile', desc: 'Lavora con quello che c\'è. Ombre dure? Usale. Pioggia? Riflessi. Neon? Atmosfera.' },
    { nome: 'Zone Focusing', desc: 'Prefissa il fuoco a 2-3 metri, f/8. Non devi mettere a fuoco, solo reagire.' },
    { nome: 'Momento Decisivo', desc: 'Non esiste la foto perfetta — esiste il momento vero. Scatta prima di pensare.' }
  ];
  
  return (
    <div>
      {principles.map((p, i) => (
        <div key={i} className="principle-card">
          <h3>{i + 1}. {p.nome}</h3>
          <p>{p.desc}</p>
        </div>
      ))}
      
      <div className="dual-setup">
        <div className="setup-col reflex">
          <h4>📷 Setup Reflex</h4>
          <p>35mm • f/8 • 1/250s • Fuoco manuale 2.5m • ISO Auto</p>
        </div>
        <div className="setup-col iphone">
          <h4>📱 Setup iPhone</h4>
          <p>1x (24mm) • Tap rapido • Non inquadrare troppo • Correggi dopo</p>
        </div>
      </div>
    </div>
  );
}
// B/N Section
function BiancoNeroSection() {
  const quando_si = [
    'Contrasto forte luce/ombra',
    'Texture e pattern interessanti',
    'Emozioni intense, drammatiche',
    'Architettura geometrica',
    'Ritratti caratteriali',
    'Atmosfera nebbiosa, malinconica',
    'Scene con troppi colori distraenti'
  ];
  
  const quando_no = [
    'Il colore È il soggetto (tramonto, fiori)',
    'Palette cromatica armoniosa',
    'Atmosfera allegra, vivace',
    'Food photography',
    'Moda colorata',
    'Scene con significato simbolico del colore'
  ];
  
  return (
    <div>
      <div className="bw-grid">
        <div className="bw-col yes">
          <h3>✓ Quando Funziona</h3>
          <ul>
            {quando_si.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
        <div className="bw-col no">
          <h3>✗ Quando Evitare</h3>
          <ul>
            {quando_no.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
      </div>
      
      <div className="exercise-box">
        <h3>🎯 Esercizio: Vedere in B/N</h3>
        <p>Prima di scattare, chiudi gli occhi e immagina la scena senza colore. Cosa resta? Se resta qualcosa di forte — forme, contrasti, emozione — scatta in B/N.</p>
        <p><strong>Trucco iPhone:</strong> Attiva il filtro B/N in anteprima (Impostazioni → Fotocamera → Filtri). Vedrai la scena in bianco e nero PRIMA di scattare.</p>
      </div>
    </div>
  );
}
// Print Calculator
function CalcolatoreStampa() {
  const [mp, setMp] = useState(24);
  
  const printSizes = [
    { name: '10×15 cm', pixels: 1800 * 1200 },
    { name: '13×18 cm', pixels: 2160 * 1440 },
    { name: '20×30 cm', pixels: 3600 * 2400 },
    { name: '30×40 cm', pixels: 4800 * 3600 },
    { name: '40×60 cm', pixels: 7200 * 4800 },
    { name: '50×70 cm', pixels: 8400 * 6000 },
    { name: '60×90 cm', pixels: 10800 * 7200 },
    { name: '100×150 cm', pixels: 18000 * 12000 }
  ];
  
  const getQuality = (mpixels, printPixels) => {
    const sensorPixels = mpixels * 1000000;
    const ratio = sensorPixels / printPixels;
    if (ratio >= 1.5) return { stars: '★★★', label: 'Eccellente' };
    if (ratio >= 0.8) return { stars: '★★☆', label: 'Buona' };
    if (ratio >= 0.4) return { stars: '★☆☆', label: 'Accettabile' };
    return { stars: '☆☆☆', label: 'Sconsigliata' };
  };
  
  return (
    <div className="calc-container">
      <h3>🖨️ Calcolatore Stampa</h3>
      
      <div className="mp-display">
        <div className="mp-value">{mp}</div>
        <div className="mp-label">Megapixel</div>
      </div>
      
      <input
        type="range"
        min="8"
        max="100"
        value={mp}
        onChange={e => setMp(Number(e.target.value))}
        style={{ width: '100%' }}
      />
      
      <div className="print-matrix">
        {printSizes.map((size, i) => {
          const q = getQuality(mp, size.pixels);
          return (
            <div key={i} className="print-cell">
              <div className="size">{size.name}</div>
              <div className="quality" title={q.label}>{q.stars}</div>
            </div>
          );
        })}
      </div>
      
      <div className="quality-legend">
        <span>★★★ Eccellente (300 DPI)</span>
        <span>★★☆ Buona</span>
        <span>★☆☆ Accettabile</span>
        <span>☆☆☆ Sconsigliata</span>
      </div>
    </div>
  );
}
// Glossario termini fotografici
const GLOSSARIO = [
  // ESPOSIZIONE
  { termine: 'Esposizione', categoria: 'base', definizione: 'Quantità di luce che raggiunge il sensore. Determinata da diaframma, tempo e ISO.' },
  { termine: 'Stop', categoria: 'base', definizione: 'Unità di misura della luce. +1 stop = doppia luce. -1 stop = metà luce. Ogni parametro (diaframma, tempo, ISO) si misura in stop.' },
  { termine: 'EV (Exposure Value)', categoria: 'base', definizione: 'Valore numerico che rappresenta una combinazione di diaframma e tempo. EV 0 = f/1, 1s. Ogni +1 EV dimezza la luce.' },
  { termine: 'Triangolo dell\'esposizione', categoria: 'base', definizione: 'I tre parametri che controllano l\'esposizione: diaframma, tempo, ISO. Modificarne uno richiede compensare con gli altri.' },
  { termine: 'Sovraesposto', categoria: 'base', definizione: 'Troppa luce: immagine troppo chiara, bianchi "bruciati" senza dettaglio recuperabile.' },
  { termine: 'Sottoesposto', categoria: 'base', definizione: 'Poca luce: immagine troppo scura, ombre "chiuse" senza dettaglio, rumore nelle zone scure.' },
  
  // DIAFRAMMA
  { termine: 'Diaframma (Aperture)', categoria: 'diaframma', definizione: 'Foro nell\'obiettivo che controlla quanta luce entra. Si misura in f/stop. Numeri bassi (f/1.4) = foro grande, più luce, sfondo sfocato.' },
  { termine: 'f/stop', categoria: 'diaframma', definizione: 'Scala del diaframma: f/1.4, f/2, f/2.8, f/4, f/5.6, f/8, f/11, f/16, f/22. Ogni step dimezza la luce.' },
  { termine: 'Profondità di campo (DOF)', categoria: 'diaframma', definizione: 'Zona di nitidezza davanti e dietro al punto di fuoco. Diaframma aperto (f/1.4) = DOF ridotta. Chiuso (f/16) = tutto nitido.' },
  { termine: 'Bokeh', categoria: 'diaframma', definizione: 'Qualità estetica dello sfocato. Dipende dal design delle lamelle del diaframma. Bokeh "cremoso" = transizione morbida.' },
  { termine: 'Iperfocale', categoria: 'diaframma', definizione: 'Distanza di messa a fuoco che massimizza la profondità di campo da metà di quella distanza a infinito. Usata nello street per non dover mettere a fuoco.' },
  
  // TEMPO
  { termine: 'Tempo di scatto (Shutter)', categoria: 'tempo', definizione: 'Durata dell\'apertura dell\'otturatore. 1/1000s = veloce, congela. 1/30s = lento, rischio mosso. 1s+ = lunga esposizione.' },
  { termine: 'Motion blur', categoria: 'tempo', definizione: 'Sfocatura da movimento. Il soggetto si muove durante l\'esposizione. Può essere difetto o effetto creativo.' },
  { termine: 'Panning', categoria: 'tempo', definizione: 'Tecnica: segui il soggetto in movimento con la camera durante l\'esposizione. Soggetto nitido, sfondo mosso.' },
  { termine: 'Mosso', categoria: 'tempo', definizione: 'Sfocatura da movimento della camera (camera shake) o del soggetto. Evitabile con tempi veloci o stabilizzazione.' },
  { termine: 'Lunga esposizione', categoria: 'tempo', definizione: 'Tempi da 1s a minuti. Effetto seta su acqua, scie di luci, cielo stellato. Richiede treppiede.' },
  { termine: 'Bulb', categoria: 'tempo', definizione: 'Modalità: l\'otturatore resta aperto finché tieni premuto. Per esposizioni oltre 30s.' },
  
  // ISO
  { termine: 'ISO', categoria: 'iso', definizione: 'Sensibilità del sensore alla luce. ISO 100 = poca sensibilità, immagine pulita. ISO 6400 = alta sensibilità, più rumore.' },
  { termine: 'Rumore / Grana', categoria: 'iso', definizione: 'Disturbo visivo (pixel colorati random) che aumenta con ISO alti. In digitale è "rumore", in pellicola era "grana" (più estetica).' },
  { termine: 'ISO nativo', categoria: 'iso', definizione: 'L\'ISO base del sensore (di solito 100 o 200) dove la qualità è massima. ISO più alti sono amplificazione elettronica.' },
  
  // MISURAZIONE
  { termine: 'Misurazione esposimetrica', categoria: 'misurazione', definizione: 'Come la camera misura la luce della scena per suggerire l\'esposizione.' },
  { termine: 'Matrix / Valutativa', categoria: 'misurazione', definizione: 'Misurazione su tutta la scena, bilanciata. Default per la maggior parte delle situazioni.' },
  { termine: 'Ponderata centrale', categoria: 'misurazione', definizione: 'Misurazione che dà priorità al centro del frame. Utile per ritratti centrati.' },
  { termine: 'Spot', categoria: 'misurazione', definizione: 'Misurazione su un punto piccolo (2-5% del frame). Precisione massima, usata per controluce o scene difficili.' },
  
  // LUCE
  { termine: 'Controluce', categoria: 'luce', definizione: 'Luce che viene da dietro il soggetto, verso la camera. Crea silhouette o effetto "rim light" sui bordi.' },
  { termine: 'Alte luci (Highlights)', categoria: 'luce', definizione: 'Le zone più luminose dell\'immagine. Se "bruciate", sono bianco puro senza dettaglio.' },
  { termine: 'Ombre (Shadows)', categoria: 'luce', definizione: 'Le zone più scure dell\'immagine. Se "chiuse", sono nero puro senza dettaglio.' },
  { termine: 'Gamma dinamica', categoria: 'luce', definizione: 'La differenza tra le alte luci più brillanti e le ombre più scure che il sensore può catturare. Misurata in stop.' },
  { termine: 'HDR', categoria: 'luce', definizione: 'High Dynamic Range: tecnica che combina più esposizioni per catturare dettaglio sia nelle ombre che nelle luci.' },
  { termine: 'Bracketing', categoria: 'luce', definizione: 'Scattare più foto della stessa scena a esposizioni diverse (-1, 0, +1 stop). Base per HDR.' },
  
  // COLORE
  { termine: 'Bilanciamento del bianco', categoria: 'colore', definizione: 'Correzione del colore in base alla temperatura della luce. Il bianco deve apparire bianco, non giallo o blu.' },
  { termine: 'Temperatura colore (Kelvin)', categoria: 'colore', definizione: 'Misura del "calore" della luce. 3000K = luce calda/arancione (candela). 6500K = luce fredda/blu (cielo nuvoloso).' },
  { termine: 'Saturazione', categoria: 'colore', definizione: 'Intensità dei colori. Alta saturazione = colori vividi. Bassa = colori spenti, tendenti al grigio.' },
  
  // OTTICA
  { termine: 'Lunghezza focale', categoria: 'ottica', definizione: 'Distanza ottica dell\'obiettivo in mm. 24mm = grandangolo (campo ampio). 85mm = tele (campo stretto, compressione).' },
  { termine: 'Grandangolo', categoria: 'ottica', definizione: 'Focale corta (14-35mm). Campo visivo ampio, esagera le distanze, distorce ai bordi. Paesaggi, architettura, street.' },
  { termine: 'Teleobiettivo', categoria: 'ottica', definizione: 'Focale lunga (85mm+). Campo stretto, comprime le distanze, isola il soggetto. Ritratti, sport, wildlife.' },
  { termine: 'Focale normale', categoria: 'ottica', definizione: '50mm su full frame. Simile alla visione umana, né comprime né esagera. "Nifty fifty".' },
  
  // FILE
  { termine: 'RAW', categoria: 'file', definizione: 'File con tutti i dati del sensore, non elaborato. Massima flessibilità in post-produzione. Peso maggiore.' },
  { termine: 'JPEG', categoria: 'file', definizione: 'File compresso ed elaborato dalla camera. Pronto all\'uso, peso ridotto, meno margine di correzione.' },
  { termine: 'Istogramma', categoria: 'file', definizione: 'Grafico che mostra la distribuzione dei toni dal nero (sinistra) al bianco (destra). Utile per verificare l\'esposizione.' },
];
function Glossario() {
  const [isOpen, setIsOpen] = useState(false);
  const [filtro, setFiltro] = useState('tutti');
  const [ricerca, setRicerca] = useState('');
  
  const categorie = ['tutti', 'base', 'diaframma', 'tempo', 'iso', 'misurazione', 'luce', 'colore', 'ottica', 'file'];
  
  const categoriaLabel = {
    tutti: 'Tutti',
    base: '📊 Esposizione',
    diaframma: '🔘 Diaframma',
    tempo: '⏱️ Tempo',
    iso: '📶 ISO',
    misurazione: '📏 Misurazione',
    luce: '💡 Luce',
    colore: '🎨 Colore',
    ottica: '🔭 Ottica',
    file: '💾 File'
  };
  
  const terminiFiltrati = GLOSSARIO.filter(g => {
    const matchCategoria = filtro === 'tutti' || g.categoria === filtro;
    const matchRicerca = ricerca === '' || 
      g.termine.toLowerCase().includes(ricerca.toLowerCase()) ||
      g.definizione.toLowerCase().includes(ricerca.toLowerCase());
    return matchCategoria && matchRicerca;
  });
  
  return (
    <div className="glossario">
      <button 
        className="glossario-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>📖 Glossario</span>
        <span className="glossario-count">{GLOSSARIO.length} termini</span>
        <span className={`glossario-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      
      {isOpen && (
        <div className="glossario-content">
          <input
            type="text"
            className="glossario-search"
            placeholder="Cerca termine..."
            value={ricerca}
            onChange={e => setRicerca(e.target.value)}
          />
          
          <div className="glossario-filtri">
            {categorie.map(cat => (
              <button
                key={cat}
                className={`filtro-btn ${filtro === cat ? 'active' : ''}`}
                onClick={() => setFiltro(cat)}
              >
                {categoriaLabel[cat]}
              </button>
            ))}
          </div>
          
          <div className="glossario-lista">
            {terminiFiltrati.map((g, i) => (
              <div key={i} className="glossario-item">
                <dt>{g.termine}</dt>
                <dd>{g.definizione}</dd>
              </div>
            ))}
            {terminiFiltrati.length === 0 && (
              <p className="glossario-empty">Nessun termine trovato</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
// Tools Section
// Inizia Section - Onboarding
function IniziaSection({ setTab }) {
  const percorso = [
    {
      settimana: 1,
      titolo: 'Padroneggia la luce',
      desc: 'Il triangolo dell\'esposizione: diaframma, tempo, ISO.',
      azioni: [
        'Vai al Simulatore e gioca con i controlli',
        'Porta ogni parametro all\'estremo: cosa succede?',
        'Trova 3 combinazioni che danno la stessa esposizione'
      ],
      tab: 'simulatore'
    },
    {
      settimana: 2,
      titolo: 'Scegli un maestro',
      desc: 'Non imparare da tutti. Scegline UNO.',
      azioni: [
        'Leggi tutti i 14 maestri, velocemente',
        'Scegline uno che ti interessa',
        'Leggi la sua scheda 3 volte, lentamente'
      ],
      tab: 'maestri'
    },
    {
      settimana: 3,
      titolo: 'Esci e imita',
      desc: 'Fai la missione del tuo maestro. Ogni giorno, per 7 giorni.',
      azioni: [
        'Segui la missione 🎯 del tuo maestro',
        'Scatta almeno 20 foto al giorno',
        'Non editare — solo scattare'
      ],
      tab: 'maestri'
    },
    {
      settimana: 4,
      titolo: 'Analizza e scegli',
      desc: 'Guarda tutto quello che hai scattato.',
      azioni: [
        'Delle ~140 foto, scegline 7 (una al giorno)',
        'Per ognuna: cosa funziona? Cosa no?',
        'Confronta con le foto del maestro'
      ],
      tab: null
    },
    {
      settimana: 5,
      titolo: 'Cambia maestro o scenario',
      desc: 'Ora hai una base. Esplora qualcosa di diverso.',
      azioni: [
        'Scegli un nuovo maestro, oppure...',
        'Applica il primo maestro a uno scenario specifico',
        'Ripeti il ciclo scatta→analizza→scegli'
      ],
      tab: 'scenari'
    }
  ];
  
  return (
    <div className="inizia-section">
      {/* ISTRUZIONI APP */}
      <div className="istruzioni-app">
        <h3>Come usare l'app</h3>
        <ul>
          <li><strong>⚡ Simulatore</strong> — Muovi i cursori, guarda cosa cambia.</li>
          <li><strong>🎨 Maestri</strong> — 14 fotografi. Tocca per aprire, leggi, fai la missione.</li>
          <li><strong>📋 Scenari</strong> — 15 situazioni con impostazioni iPhone.</li>
          <li><strong>🚶 Street</strong> — Fotografia di strada.</li>
          <li><strong>◐ B/N</strong> — Bianco e nero.</li>
          <li><strong>🔧 Strumenti</strong> — Glossario.</li>
        </ul>
      </div>
      
      <hr className="sezione-divider" />
      
      {/* PERCORSO */}
      <div className="inizia-intro">
        <h3>Percorso consigliato</h3>
        <p>Se non sai da dove partire, segui queste 5 settimane.</p>
      </div>
      
      <div className="percorso-lista">
        {percorso.map((step, i) => (
          <div key={i} className="percorso-step">
            <div className="step-header">
              <span className="step-badge">Settimana {step.settimana}</span>
              <h3>{step.titolo}</h3>
            </div>
            <p className="step-desc">{step.desc}</p>
            <ul className="step-azioni">
              {step.azioni.map((a, j) => (
                <li key={j}>{a}</li>
              ))}
            </ul>
            {step.tab && (
              <button className="step-go" onClick={() => setTab(step.tab)}>
                Vai a {step.tab === 'simulatore' ? '⚡ Simulatore' : step.tab === 'maestri' ? '🎨 Maestri' : '📋 Scenari'} →
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
function StrumentiSection() {
  return (
    <div>
      <Glossario />
      
      <CalcolatoreStampa />
      
      <h3 className="section-title">📐 Regole di Composizione</h3>
      <div className="comp-grid">
        {COMPOSIZIONE.map((c, i) => (
          <div key={i} className="comp-card">
            <h4>{c.nome}</h4>
            <p>{c.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
// ============================================
// SCROLL TO TOP BUTTON
// ============================================
function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      className="scroll-to-top visible"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Torna su"
    >
      ▲
    </button>
  );
}

// ============================================
// MAIN APP
// ============================================
export default function App() {
  const [tab, setTab] = useState('simulatore');
  const [highlightedMaestro, setHighlightedMaestro] = useState(null);

  // Scroll to top on tab change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [tab]);

  // Cross-navigation: scenario maestro tag → maestri tab
  const navigateToMaestro = useCallback((maestroId) => {
    setHighlightedMaestro(maestroId);
    setTab('maestri');
  }, []);

  const clearHighlight = useCallback(() => {
    setHighlightedMaestro(null);
  }, []);

  const tabs = [
    { id: 'simulatore', label: 'Simulatore', icon: '⚡' },
    { id: 'maestri', label: 'Maestri', icon: '🎨' },
    { id: 'scenari', label: 'Scenari', icon: '📋' },
    { id: 'street', label: 'Street', icon: '🚶' },
    { id: 'bw', label: 'B/N', icon: '◐' },
    { id: 'primi-passi', label: 'Primi Passi', icon: '🧭' },
    { id: 'strumenti', label: 'Strumenti', icon: '🔧' }
  ];

  return (
    <>
      <style>{styles}</style>
      <div className="app">
        <header className="header">
          <h1>Scrivere con la luce</h1>
          <p className="subtitle">Lo sguardo e la strada</p>
        </header>

        <nav className="nav">
          {tabs.map(t => (
            <button
              key={t.id}
              className={`nav-btn ${tab === t.id ? 'active' : ''}`}
              onClick={() => setTab(t.id)}
            >
              <span>{t.icon}</span>
              {t.label}
            </button>
          ))}
        </nav>

        <main className="section">
          {tab === 'simulatore' && (
            <>
              <h2 className="section-title">⚡ Simulatore Esposizione</h2>
              <SimulatoreEsposizione />
            </>
          )}

          {tab === 'maestri' && (
            <>
              <h2 className="section-title">🎨 I Maestri</h2>
              <MaestriSection
                highlightedMaestro={highlightedMaestro}
                onHighlightClear={clearHighlight}
              />
            </>
          )}

          {tab === 'scenari' && (
            <>
              <h2 className="section-title">📋 Scenari Classici</h2>
              <ScenariSection onMaestroClick={navigateToMaestro} />
            </>
          )}

          {tab === 'street' && (
            <>
              <h2 className="section-title">🚶 Street Photography</h2>
              <StreetSection />
            </>
          )}

          {tab === 'bw' && (
            <>
              <h2 className="section-title">◐ Bianco e Nero</h2>
              <BiancoNeroSection />
            </>
          )}

          {tab === 'primi-passi' && (
            <>
              <h2 className="section-title">🧭 Primi Passi</h2>
              <IniziaSection setTab={setTab} />
            </>
          )}

          {tab === 'strumenti' && (
            <>
              <h2 className="section-title">🔧 Strumenti</h2>
              <StrumentiSection />
            </>
          )}
        </main>
      </div>

      <ScrollToTop />
    </>
  );
}